//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface IUserFormClient {

    getAddUserForm(): Promise<ResponsePayloadOfUserForm>;

    getUserForm(userId: string): Promise<ResponsePayloadOfUserForm>;

    saveUserForm(userId: string, userForm: UserForm): Promise<ResponsePayloadOfUserForm>;

    addUserForm(userForm: UserForm): Promise<ResponsePayloadOfUserForm>;
}

export class UserFormClient implements IUserFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAddUserForm(): Promise<ResponsePayloadOfUserForm> {
        let url_ = this.baseUrl + "/add-user-form";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAddUserForm(_response);
        });
    }

    protected processGetAddUserForm(response: Response): Promise<ResponsePayloadOfUserForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfUserForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfUserForm>(null as any);
    }

    getUserForm(userId: string): Promise<ResponsePayloadOfUserForm> {
        let url_ = this.baseUrl + "/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserForm(_response);
        });
    }

    protected processGetUserForm(response: Response): Promise<ResponsePayloadOfUserForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfUserForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfUserForm>(null as any);
    }

    saveUserForm(userId: string, userForm: UserForm): Promise<ResponsePayloadOfUserForm> {
        let url_ = this.baseUrl + "/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userForm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveUserForm(_response);
        });
    }

    protected processSaveUserForm(response: Response): Promise<ResponsePayloadOfUserForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfUserForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfUserForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfUserForm>(null as any);
    }

    addUserForm(userForm: UserForm): Promise<ResponsePayloadOfUserForm> {
        let url_ = this.baseUrl + "/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userForm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddUserForm(_response);
        });
    }

    protected processAddUserForm(response: Response): Promise<ResponsePayloadOfUserForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfUserForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfUserForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfUserForm>(null as any);
    }
}

export interface IUserAdminFormClient {

    getUserAdmin(): Promise<ResponsePayloadOfUserAdminForm>;
}

export class UserAdminFormClient implements IUserAdminFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getUserAdmin(): Promise<ResponsePayloadOfUserAdminForm> {
        let url_ = this.baseUrl + "/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserAdmin(_response);
        });
    }

    protected processGetUserAdmin(response: Response): Promise<ResponsePayloadOfUserAdminForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfUserAdminForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfUserAdminForm>(null as any);
    }
}

export interface ISiteClient {

    getSite(): Promise<ResponsePayloadOfSite>;
}

export class SiteClient implements ISiteClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getSite(): Promise<ResponsePayloadOfSite> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSite(_response);
        });
    }

    protected processGetSite(response: Response): Promise<ResponsePayloadOfSite> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfSite;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfSite>(null as any);
    }
}

export interface IReviewSummaryFormClient {

    getForm(batchId: string): Promise<ResponsePayloadOfReviewSummaryForm>;

    getFormForFilters(batchId: string, form: ReviewSummaryForm): Promise<ResponsePayloadOfReviewSummaryForm>;

    approveForm(batchId: string, form: ReviewSummaryForm): Promise<ResponsePayloadOfReviewSummaryForm>;

    rejectForm(batchId: string, form: ReviewSummaryForm): Promise<ResponsePayloadOfReviewSummaryForm>;

    addPropertyComment(batchId: string, propertyId: string, text: string): Promise<ResponsePayloadOfListOfCommonSummaryFormComment>;

    deletePropertyComment(batchId: string, propertyId: string, commentId: number): Promise<ResponsePayloadOfListOfCommonSummaryFormComment>;

    addUnitComment(batchId: string, unitId: string, text: string): Promise<ResponsePayloadOfListOfCommonSummaryFormComment>;

    deleteUnitComment(batchId: string, unitId: string, commentId: number): Promise<ResponsePayloadOfListOfCommonSummaryFormComment>;
}

export class ReviewSummaryFormClient implements IReviewSummaryFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getForm(batchId: string): Promise<ResponsePayloadOfReviewSummaryForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/review-summary-form";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetForm(_response);
        });
    }

    protected processGetForm(response: Response): Promise<ResponsePayloadOfReviewSummaryForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfReviewSummaryForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfReviewSummaryForm;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfReviewSummaryForm>(null as any);
    }

    getFormForFilters(batchId: string, form: ReviewSummaryForm): Promise<ResponsePayloadOfReviewSummaryForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/review-summary-form";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFormForFilters(_response);
        });
    }

    protected processGetFormForFilters(response: Response): Promise<ResponsePayloadOfReviewSummaryForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfReviewSummaryForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfReviewSummaryForm;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfReviewSummaryForm>(null as any);
    }

    approveForm(batchId: string, form: ReviewSummaryForm): Promise<ResponsePayloadOfReviewSummaryForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/accept-review-summary-form";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApproveForm(_response);
        });
    }

    protected processApproveForm(response: Response): Promise<ResponsePayloadOfReviewSummaryForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfReviewSummaryForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfReviewSummaryForm;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfReviewSummaryForm>(null as any);
    }

    rejectForm(batchId: string, form: ReviewSummaryForm): Promise<ResponsePayloadOfReviewSummaryForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/reject-review-summary-form";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRejectForm(_response);
        });
    }

    protected processRejectForm(response: Response): Promise<ResponsePayloadOfReviewSummaryForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfReviewSummaryForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfReviewSummaryForm;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfReviewSummaryForm>(null as any);
    }

    addPropertyComment(batchId: string, propertyId: string, text: string): Promise<ResponsePayloadOfListOfCommonSummaryFormComment> {
        let url_ = this.baseUrl + "/batches/{batchId}/review-summary-form/properties/{propertyId}/comments";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (propertyId === undefined || propertyId === null)
            throw new globalThis.Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(text);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddPropertyComment(_response);
        });
    }

    protected processAddPropertyComment(response: Response): Promise<ResponsePayloadOfListOfCommonSummaryFormComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfListOfCommonSummaryFormComment;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfCommonSummaryFormComment;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfListOfCommonSummaryFormComment>(null as any);
    }

    deletePropertyComment(batchId: string, propertyId: string, commentId: number): Promise<ResponsePayloadOfListOfCommonSummaryFormComment> {
        let url_ = this.baseUrl + "/batches/{batchId}/review-summary-form/properties/{propertyId}/comments";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (propertyId === undefined || propertyId === null)
            throw new globalThis.Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commentId);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePropertyComment(_response);
        });
    }

    protected processDeletePropertyComment(response: Response): Promise<ResponsePayloadOfListOfCommonSummaryFormComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfListOfCommonSummaryFormComment;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfCommonSummaryFormComment;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfListOfCommonSummaryFormComment>(null as any);
    }

    addUnitComment(batchId: string, unitId: string, text: string): Promise<ResponsePayloadOfListOfCommonSummaryFormComment> {
        let url_ = this.baseUrl + "/batches/{batchId}/review-summary-form-form/units/{unitId}/comments";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (unitId === undefined || unitId === null)
            throw new globalThis.Error("The parameter 'unitId' must be defined.");
        url_ = url_.replace("{unitId}", encodeURIComponent("" + unitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(text);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddUnitComment(_response);
        });
    }

    protected processAddUnitComment(response: Response): Promise<ResponsePayloadOfListOfCommonSummaryFormComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfListOfCommonSummaryFormComment;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfCommonSummaryFormComment;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfListOfCommonSummaryFormComment>(null as any);
    }

    deleteUnitComment(batchId: string, unitId: string, commentId: number): Promise<ResponsePayloadOfListOfCommonSummaryFormComment> {
        let url_ = this.baseUrl + "/batches/{batchId}/review-summary-form-form/units/{unitId}/comments";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (unitId === undefined || unitId === null)
            throw new globalThis.Error("The parameter 'unitId' must be defined.");
        url_ = url_.replace("{unitId}", encodeURIComponent("" + unitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commentId);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUnitComment(_response);
        });
    }

    protected processDeleteUnitComment(response: Response): Promise<ResponsePayloadOfListOfCommonSummaryFormComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfListOfCommonSummaryFormComment;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfCommonSummaryFormComment;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfListOfCommonSummaryFormComment>(null as any);
    }
}

export interface IRenewalFollowUpFormClient {

    getForm(batchId: string): Promise<ResponsePayloadOfRenewalFollowUpForm>;

    getFormForFilters(batchId: string, form: RenewalFollowUpForm): Promise<ResponsePayloadOfRenewalFollowUpForm>;
}

export class RenewalFollowUpFormClient implements IRenewalFollowUpFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getForm(batchId: string): Promise<ResponsePayloadOfRenewalFollowUpForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/renewal-follow-up";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetForm(_response);
        });
    }

    protected processGetForm(response: Response): Promise<ResponsePayloadOfRenewalFollowUpForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfRenewalFollowUpForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfRenewalFollowUpForm;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfRenewalFollowUpForm>(null as any);
    }

    getFormForFilters(batchId: string, form: RenewalFollowUpForm): Promise<ResponsePayloadOfRenewalFollowUpForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/renewal-follow-up";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFormForFilters(_response);
        });
    }

    protected processGetFormForFilters(response: Response): Promise<ResponsePayloadOfRenewalFollowUpForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfRenewalFollowUpForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfRenewalFollowUpForm;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfRenewalFollowUpForm>(null as any);
    }
}

export interface IHelpFormClient {

    getAtlasGuideHelpDownloadForm(): Promise<ResponsePayloadOfAtlasHelpFormDownload>;
}

export class HelpFormClient implements IHelpFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAtlasGuideHelpDownloadForm(): Promise<ResponsePayloadOfAtlasHelpFormDownload> {
        let url_ = this.baseUrl + "/help/atlas-guide";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAtlasGuideHelpDownloadForm(_response);
        });
    }

    protected processGetAtlasGuideHelpDownloadForm(response: Response): Promise<ResponsePayloadOfAtlasHelpFormDownload> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfAtlasHelpFormDownload;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfAtlasHelpFormDownload;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfAtlasHelpFormDownload>(null as any);
    }
}

export interface IDefaultsAdminGtlAndLtlFormClient {

    getDefaultsAdminGtlAndLtlForm(): Promise<ResponsePayloadOfDefaultsAdminGtlAndLtlForm>;

    saveDefaultsAdminGtlAndLtlForm(form: DefaultsAdminGtlAndLtlForm): Promise<ResponsePayloadOfDefaultsAdminGtlAndLtlForm>;
}

export class DefaultsAdminGtlAndLtlFormClient implements IDefaultsAdminGtlAndLtlFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getDefaultsAdminGtlAndLtlForm(): Promise<ResponsePayloadOfDefaultsAdminGtlAndLtlForm> {
        let url_ = this.baseUrl + "/defaultsadmin/gtl-and-ltl-form";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDefaultsAdminGtlAndLtlForm(_response);
        });
    }

    protected processGetDefaultsAdminGtlAndLtlForm(response: Response): Promise<ResponsePayloadOfDefaultsAdminGtlAndLtlForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfDefaultsAdminGtlAndLtlForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfDefaultsAdminGtlAndLtlForm>(null as any);
    }

    saveDefaultsAdminGtlAndLtlForm(form: DefaultsAdminGtlAndLtlForm): Promise<ResponsePayloadOfDefaultsAdminGtlAndLtlForm> {
        let url_ = this.baseUrl + "/defaultsadmin/gtl-and-ltl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveDefaultsAdminGtlAndLtlForm(_response);
        });
    }

    protected processSaveDefaultsAdminGtlAndLtlForm(response: Response): Promise<ResponsePayloadOfDefaultsAdminGtlAndLtlForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfDefaultsAdminGtlAndLtlForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfDefaultsAdminGtlAndLtlForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfDefaultsAdminGtlAndLtlForm>(null as any);
    }
}

export interface IDefaultsAdminGrowthRatesFormClient {

    getDefaultsAdminGrowthRatesForm(): Promise<ResponsePayloadOfDefaultsAdminGrowthRatesForm>;

    saveDefaultsAdminGrowthRatesForm(defaultsAdminGrowthRatesForm: DefaultsAdminGrowthRatesForm): Promise<ResponsePayloadOfDefaultsAdminGrowthRatesForm>;
}

export class DefaultsAdminGrowthRatesFormClient implements IDefaultsAdminGrowthRatesFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getDefaultsAdminGrowthRatesForm(): Promise<ResponsePayloadOfDefaultsAdminGrowthRatesForm> {
        let url_ = this.baseUrl + "/defaultsadmin/growth-rate-form";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDefaultsAdminGrowthRatesForm(_response);
        });
    }

    protected processGetDefaultsAdminGrowthRatesForm(response: Response): Promise<ResponsePayloadOfDefaultsAdminGrowthRatesForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfDefaultsAdminGrowthRatesForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfDefaultsAdminGrowthRatesForm>(null as any);
    }

    saveDefaultsAdminGrowthRatesForm(defaultsAdminGrowthRatesForm: DefaultsAdminGrowthRatesForm): Promise<ResponsePayloadOfDefaultsAdminGrowthRatesForm> {
        let url_ = this.baseUrl + "/defaultsadmin/growth-rates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(defaultsAdminGrowthRatesForm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveDefaultsAdminGrowthRatesForm(_response);
        });
    }

    protected processSaveDefaultsAdminGrowthRatesForm(response: Response): Promise<ResponsePayloadOfDefaultsAdminGrowthRatesForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfDefaultsAdminGrowthRatesForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfDefaultsAdminGrowthRatesForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfDefaultsAdminGrowthRatesForm>(null as any);
    }
}

export interface ICreateBatchFormClient {

    getCreateBatchForm(): Promise<ResponsePayloadOfCreateBatchForm>;

    createBatch(createBatchForm: CreateBatchForm): Promise<ResponsePayloadOfCreateBatchForm>;

    getCreateOneOffBatchForm(): Promise<ResponsePayloadOfCreateOneOffBatchForm>;

    createOneOffBatch(createBatchForm: CreateOneOffBatchForm): Promise<ResponsePayloadOfCreateOneOffBatchForm>;
}

export class CreateBatchFormClient implements ICreateBatchFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCreateBatchForm(): Promise<ResponsePayloadOfCreateBatchForm> {
        let url_ = this.baseUrl + "/create-batch-form";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCreateBatchForm(_response);
        });
    }

    protected processGetCreateBatchForm(response: Response): Promise<ResponsePayloadOfCreateBatchForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfCreateBatchForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfCreateBatchForm>(null as any);
    }

    createBatch(createBatchForm: CreateBatchForm): Promise<ResponsePayloadOfCreateBatchForm> {
        let url_ = this.baseUrl + "/batches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createBatchForm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBatch(_response);
        });
    }

    protected processCreateBatch(response: Response): Promise<ResponsePayloadOfCreateBatchForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfCreateBatchForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfCreateBatchForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfCreateBatchForm>(null as any);
    }

    getCreateOneOffBatchForm(): Promise<ResponsePayloadOfCreateOneOffBatchForm> {
        let url_ = this.baseUrl + "/create-one-off-batch-form";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCreateOneOffBatchForm(_response);
        });
    }

    protected processGetCreateOneOffBatchForm(response: Response): Promise<ResponsePayloadOfCreateOneOffBatchForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfCreateOneOffBatchForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfCreateOneOffBatchForm>(null as any);
    }

    createOneOffBatch(createBatchForm: CreateOneOffBatchForm): Promise<ResponsePayloadOfCreateOneOffBatchForm> {
        let url_ = this.baseUrl + "/one-off-batches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createBatchForm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOneOffBatch(_response);
        });
    }

    protected processCreateOneOffBatch(response: Response): Promise<ResponsePayloadOfCreateOneOffBatchForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfCreateOneOffBatchForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfCreateBatchForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfCreateOneOffBatchForm>(null as any);
    }
}

export interface IBatchListFormClient {

    getBatchList(): Promise<ResponsePayloadOfBatchListForm>;
}

export class BatchListFormClient implements IBatchListFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBatchList(): Promise<ResponsePayloadOfBatchListForm> {
        let url_ = this.baseUrl + "/batches";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBatchList(_response);
        });
    }

    protected processGetBatchList(response: Response): Promise<ResponsePayloadOfBatchListForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchListForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchListForm>(null as any);
    }
}

export interface IBestRenewalOffersActualsFormClient {

    getForm(batchId: string): Promise<ResponsePayloadOfBestRenewalOffersForm>;

    saveForm(batchId: string, form: BestRenewalOffersForm): Promise<ResponsePayloadOfBestRenewalOffersForm>;

    downloadForm(batchId: string): Promise<ResponsePayloadOfBestRenewalOffersFormDownload>;
}

export class BestRenewalOffersActualsFormClient implements IBestRenewalOffersActualsFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getForm(batchId: string): Promise<ResponsePayloadOfBestRenewalOffersForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/best-renewal-offers-actuals-form";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetForm(_response);
        });
    }

    protected processGetForm(response: Response): Promise<ResponsePayloadOfBestRenewalOffersForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersForm;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBestRenewalOffersForm>(null as any);
    }

    saveForm(batchId: string, form: BestRenewalOffersForm): Promise<ResponsePayloadOfBestRenewalOffersForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/best-renewal-offers-actuals-form";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveForm(_response);
        });
    }

    protected processSaveForm(response: Response): Promise<ResponsePayloadOfBestRenewalOffersForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersForm;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBestRenewalOffersForm>(null as any);
    }

    downloadForm(batchId: string): Promise<ResponsePayloadOfBestRenewalOffersFormDownload> {
        let url_ = this.baseUrl + "/batches/{batchId}/download-best-renewal-offers-actuals-form";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadForm(_response);
        });
    }

    protected processDownloadForm(response: Response): Promise<ResponsePayloadOfBestRenewalOffersFormDownload> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersFormDownload;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersFormDownload;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBestRenewalOffersFormDownload>(null as any);
    }
}

export interface IBestRenewalOffersFormClient {

    getForm(batchId: string): Promise<ResponsePayloadOfBestRenewalOffersForm>;

    getFilteredForm(batchId: string, filters: ReviewSummaryFormFilters): Promise<ResponsePayloadOfBestRenewalOffersForm>;

    deleteForm(batchId: string): Promise<ResponsePayloadOfVoidResponse>;

    saveForm(batchId: string, form: BestRenewalOffersForm): Promise<ResponsePayloadOfBestRenewalOffersForm>;

    submitForm(batchId: string, form: BestRenewalOffersForm): Promise<ResponsePayloadOfBestRenewalOffersForm>;

    approveForm(batchId: string, form: BestRenewalOffersForm): Promise<ResponsePayloadOfBestRenewalOffersForm>;

    rejectForm(batchId: string, form: BestRenewalOffersForm): Promise<ResponsePayloadOfBestRenewalOffersForm>;

    exportForm(batchId: string, form: BestRenewalOffersForm): Promise<ResponsePayloadOfBestRenewalOffersForm>;

    addPropertyComment(batchId: string, propertyId: string, text: string): Promise<ResponsePayloadOfListOfBestRenewalOffersFormComment>;

    deletePropertyComment(batchId: string, propertyId: string, commentId: number): Promise<ResponsePayloadOfListOfBestRenewalOffersFormComment>;

    addUnitComment(batchId: string, unitId: string, text: string): Promise<ResponsePayloadOfListOfBestRenewalOffersFormComment>;

    deleteUnitComment(batchId: string, unitId: string, commentId: number): Promise<ResponsePayloadOfListOfBestRenewalOffersFormComment>;

    calculateOffer(batchId: string, offersInSingleProperty: BestRenewalOffersFormOffer[]): Promise<ResponsePayloadOfBestRenewalOffersFormCalculationResult>;

    calculateMultipleOffers(batchId: string, offersInMultipleProperties: BestRenewalOffersFormOffer[]): Promise<ResponsePayloadOfBestRenewalOffersFormCalculationResult>;
}

export class BestRenewalOffersFormClient implements IBestRenewalOffersFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getForm(batchId: string): Promise<ResponsePayloadOfBestRenewalOffersForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/best-renewal-offers-form";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetForm(_response);
        });
    }

    protected processGetForm(response: Response): Promise<ResponsePayloadOfBestRenewalOffersForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersForm;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBestRenewalOffersForm>(null as any);
    }

    getFilteredForm(batchId: string, filters: ReviewSummaryFormFilters): Promise<ResponsePayloadOfBestRenewalOffersForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/best-renewal-offers-form";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredForm(_response);
        });
    }

    protected processGetFilteredForm(response: Response): Promise<ResponsePayloadOfBestRenewalOffersForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersForm;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBestRenewalOffersForm>(null as any);
    }

    deleteForm(batchId: string): Promise<ResponsePayloadOfVoidResponse> {
        let url_ = this.baseUrl + "/batches/{batchId}/best-renewal-offers-form";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteForm(_response);
        });
    }

    protected processDeleteForm(response: Response): Promise<ResponsePayloadOfVoidResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfVoidResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfVoidResponse;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfVoidResponse>(null as any);
    }

    saveForm(batchId: string, form: BestRenewalOffersForm): Promise<ResponsePayloadOfBestRenewalOffersForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/best-renewal-offers-form";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveForm(_response);
        });
    }

    protected processSaveForm(response: Response): Promise<ResponsePayloadOfBestRenewalOffersForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersForm;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBestRenewalOffersForm>(null as any);
    }

    submitForm(batchId: string, form: BestRenewalOffersForm): Promise<ResponsePayloadOfBestRenewalOffersForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/submit-best-renewal-offer";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubmitForm(_response);
        });
    }

    protected processSubmitForm(response: Response): Promise<ResponsePayloadOfBestRenewalOffersForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersForm;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBestRenewalOffersForm>(null as any);
    }

    approveForm(batchId: string, form: BestRenewalOffersForm): Promise<ResponsePayloadOfBestRenewalOffersForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/approve-best-renewal-offers-form";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApproveForm(_response);
        });
    }

    protected processApproveForm(response: Response): Promise<ResponsePayloadOfBestRenewalOffersForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersForm;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBestRenewalOffersForm>(null as any);
    }

    rejectForm(batchId: string, form: BestRenewalOffersForm): Promise<ResponsePayloadOfBestRenewalOffersForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/reject-best-renewal-offers-form";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRejectForm(_response);
        });
    }

    protected processRejectForm(response: Response): Promise<ResponsePayloadOfBestRenewalOffersForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersForm;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBestRenewalOffersForm>(null as any);
    }

    exportForm(batchId: string, form: BestRenewalOffersForm): Promise<ResponsePayloadOfBestRenewalOffersForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/export-best-renewal-offers-form";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportForm(_response);
        });
    }

    protected processExportForm(response: Response): Promise<ResponsePayloadOfBestRenewalOffersForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersForm;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBestRenewalOffersForm>(null as any);
    }

    addPropertyComment(batchId: string, propertyId: string, text: string): Promise<ResponsePayloadOfListOfBestRenewalOffersFormComment> {
        let url_ = this.baseUrl + "/batches/{batchId}/best-renewal-offers-form/properties/{propertyId}/comments";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (propertyId === undefined || propertyId === null)
            throw new globalThis.Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(text);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddPropertyComment(_response);
        });
    }

    protected processAddPropertyComment(response: Response): Promise<ResponsePayloadOfListOfBestRenewalOffersFormComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfListOfBestRenewalOffersFormComment;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersFormComment;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfListOfBestRenewalOffersFormComment>(null as any);
    }

    deletePropertyComment(batchId: string, propertyId: string, commentId: number): Promise<ResponsePayloadOfListOfBestRenewalOffersFormComment> {
        let url_ = this.baseUrl + "/batches/{batchId}/best-renewal-offers-form/properties/{propertyId}/comments";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (propertyId === undefined || propertyId === null)
            throw new globalThis.Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commentId);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePropertyComment(_response);
        });
    }

    protected processDeletePropertyComment(response: Response): Promise<ResponsePayloadOfListOfBestRenewalOffersFormComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfListOfBestRenewalOffersFormComment;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersFormComment;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfListOfBestRenewalOffersFormComment>(null as any);
    }

    addUnitComment(batchId: string, unitId: string, text: string): Promise<ResponsePayloadOfListOfBestRenewalOffersFormComment> {
        let url_ = this.baseUrl + "/batches/{batchId}/best-renewal-offers-form/units/{unitId}/comments";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (unitId === undefined || unitId === null)
            throw new globalThis.Error("The parameter 'unitId' must be defined.");
        url_ = url_.replace("{unitId}", encodeURIComponent("" + unitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(text);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddUnitComment(_response);
        });
    }

    protected processAddUnitComment(response: Response): Promise<ResponsePayloadOfListOfBestRenewalOffersFormComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfListOfBestRenewalOffersFormComment;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersFormComment;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfListOfBestRenewalOffersFormComment>(null as any);
    }

    deleteUnitComment(batchId: string, unitId: string, commentId: number): Promise<ResponsePayloadOfListOfBestRenewalOffersFormComment> {
        let url_ = this.baseUrl + "/batches/{batchId}/best-renewal-offers-form/units/{unitId}/comments";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (unitId === undefined || unitId === null)
            throw new globalThis.Error("The parameter 'unitId' must be defined.");
        url_ = url_.replace("{unitId}", encodeURIComponent("" + unitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commentId);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUnitComment(_response);
        });
    }

    protected processDeleteUnitComment(response: Response): Promise<ResponsePayloadOfListOfBestRenewalOffersFormComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfListOfBestRenewalOffersFormComment;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersFormComment;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfListOfBestRenewalOffersFormComment>(null as any);
    }

    calculateOffer(batchId: string, offersInSingleProperty: BestRenewalOffersFormOffer[]): Promise<ResponsePayloadOfBestRenewalOffersFormCalculationResult> {
        let url_ = this.baseUrl + "/batches/{batchId}/calculate-best-renewal-offer";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(offersInSingleProperty);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalculateOffer(_response);
        });
    }

    protected processCalculateOffer(response: Response): Promise<ResponsePayloadOfBestRenewalOffersFormCalculationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersFormCalculationResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersFormCalculationResult;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBestRenewalOffersFormCalculationResult>(null as any);
    }

    calculateMultipleOffers(batchId: string, offersInMultipleProperties: BestRenewalOffersFormOffer[]): Promise<ResponsePayloadOfBestRenewalOffersFormCalculationResult> {
        let url_ = this.baseUrl + "/batches/{batchId}/calculate-multiple-best-renewal-offer";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(offersInMultipleProperties);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalculateMultipleOffers(_response);
        });
    }

    protected processCalculateMultipleOffers(response: Response): Promise<ResponsePayloadOfBestRenewalOffersFormCalculationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersFormCalculationResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBestRenewalOffersFormCalculationResult;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBestRenewalOffersFormCalculationResult>(null as any);
    }
}

export interface IBatchDefaultsScalingFormClient {

    getBatchDefaultsScalingForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsScalingForm>;

    saveBatchDefaultsScalingForm(batchId: string, batchDefaultsScalingForm: BatchDefaultsScalingForm): Promise<ResponsePayloadOfBatchDefaultsScalingForm>;
}

export class BatchDefaultsScalingFormClient implements IBatchDefaultsScalingFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBatchDefaultsScalingForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsScalingForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/scaling";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBatchDefaultsScalingForm(_response);
        });
    }

    protected processGetBatchDefaultsScalingForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsScalingForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsScalingForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsScalingForm>(null as any);
    }

    saveBatchDefaultsScalingForm(batchId: string, batchDefaultsScalingForm: BatchDefaultsScalingForm): Promise<ResponsePayloadOfBatchDefaultsScalingForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/scaling";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(batchDefaultsScalingForm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBatchDefaultsScalingForm(_response);
        });
    }

    protected processSaveBatchDefaultsScalingForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsScalingForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsScalingForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsScalingForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsScalingForm>(null as any);
    }
}

export interface IBatchDefaultsRentControlFormClient {

    getBatchDefaultsRentControlForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsRentControlForm>;

    saveBatchDefaultsRentControlForm(batchId: string, batchDefaultsRentControlForm: BatchDefaultsRentControlForm): Promise<ResponsePayloadOfBatchDefaultsRentControlForm>;
}

export class BatchDefaultsRentControlFormClient implements IBatchDefaultsRentControlFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBatchDefaultsRentControlForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsRentControlForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/rent-control";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBatchDefaultsRentControlForm(_response);
        });
    }

    protected processGetBatchDefaultsRentControlForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsRentControlForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsRentControlForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsRentControlForm>(null as any);
    }

    saveBatchDefaultsRentControlForm(batchId: string, batchDefaultsRentControlForm: BatchDefaultsRentControlForm): Promise<ResponsePayloadOfBatchDefaultsRentControlForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/rent-control";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(batchDefaultsRentControlForm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBatchDefaultsRentControlForm(_response);
        });
    }

    protected processSaveBatchDefaultsRentControlForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsRentControlForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsRentControlForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsRentControlForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsRentControlForm>(null as any);
    }
}

export interface IBatchDefaultsRentControlTypesFormClient {

    getBatchDefaultsRentControlTypesForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsRentControlTypesForm>;

    saveBatchDefaultsRentControlTypesForm(batchId: string, batchDefaultsRentControlTypesForm: BatchDefaultsRentControlTypesForm): Promise<ResponsePayloadOfBatchDefaultsRentControlTypesForm>;
}

export class BatchDefaultsRentControlTypesFormClient implements IBatchDefaultsRentControlTypesFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBatchDefaultsRentControlTypesForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsRentControlTypesForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/rent-control-types";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBatchDefaultsRentControlTypesForm(_response);
        });
    }

    protected processGetBatchDefaultsRentControlTypesForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsRentControlTypesForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsRentControlTypesForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsRentControlTypesForm>(null as any);
    }

    saveBatchDefaultsRentControlTypesForm(batchId: string, batchDefaultsRentControlTypesForm: BatchDefaultsRentControlTypesForm): Promise<ResponsePayloadOfBatchDefaultsRentControlTypesForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/rent-control-types";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(batchDefaultsRentControlTypesForm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBatchDefaultsRentControlTypesForm(_response);
        });
    }

    protected processSaveBatchDefaultsRentControlTypesForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsRentControlTypesForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsRentControlTypesForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsRentControlTypesForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsRentControlTypesForm>(null as any);
    }
}

export interface IBatchDefaultsRenewalNoticePeriodFormClient {

    getBatchDefaultsRenewalNoticePeriodForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsRenewalNoticePeriodForm>;

    saveBatchDefaultsRenewalNoticePeriodForm(batchId: string, batchDefaultsExceptionsForm: BatchDefaultsRenewalNoticePeriodForm): Promise<ResponsePayloadOfBatchDefaultsRenewalNoticePeriodForm>;
}

export class BatchDefaultsRenewalNoticePeriodFormClient implements IBatchDefaultsRenewalNoticePeriodFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBatchDefaultsRenewalNoticePeriodForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsRenewalNoticePeriodForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/renewal-notice-period";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBatchDefaultsRenewalNoticePeriodForm(_response);
        });
    }

    protected processGetBatchDefaultsRenewalNoticePeriodForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsRenewalNoticePeriodForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsRenewalNoticePeriodForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsRenewalNoticePeriodForm>(null as any);
    }

    saveBatchDefaultsRenewalNoticePeriodForm(batchId: string, batchDefaultsExceptionsForm: BatchDefaultsRenewalNoticePeriodForm): Promise<ResponsePayloadOfBatchDefaultsRenewalNoticePeriodForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/renewal-notice-period";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(batchDefaultsExceptionsForm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBatchDefaultsRenewalNoticePeriodForm(_response);
        });
    }

    protected processSaveBatchDefaultsRenewalNoticePeriodForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsRenewalNoticePeriodForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsRenewalNoticePeriodForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsRenewalNoticePeriodForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsRenewalNoticePeriodForm>(null as any);
    }
}

export interface IBatchDefaultsRegulationsFormClient {

    getBatchDefaultsRegulationsForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsRegulationsForm>;

    saveBatchDefaultsRegulationsForm(batchId: string, batchDefaultsRegulationsForm: BatchDefaultsRegulationsForm): Promise<ResponsePayloadOfBatchDefaultsRegulationsForm>;
}

export class BatchDefaultsRegulationsFormClient implements IBatchDefaultsRegulationsFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBatchDefaultsRegulationsForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsRegulationsForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/regulations";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBatchDefaultsRegulationsForm(_response);
        });
    }

    protected processGetBatchDefaultsRegulationsForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsRegulationsForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsRegulationsForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsRegulationsForm>(null as any);
    }

    saveBatchDefaultsRegulationsForm(batchId: string, batchDefaultsRegulationsForm: BatchDefaultsRegulationsForm): Promise<ResponsePayloadOfBatchDefaultsRegulationsForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/regulations";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(batchDefaultsRegulationsForm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBatchDefaultsRegulationsForm(_response);
        });
    }

    protected processSaveBatchDefaultsRegulationsForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsRegulationsForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsRegulationsForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsRegulationsForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsRegulationsForm>(null as any);
    }
}

export interface IBatchDefaultsIncentivesFormClient {

    getBatchDefaultsIncentivesForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsIncentivesForm>;

    saveBatchDefaultsIncentivesForm(batchId: string, batchDefaultsIncentivesForm: BatchDefaultsIncentivesForm): Promise<ResponsePayloadOfBatchDefaultsIncentivesForm>;
}

export class BatchDefaultsIncentivesFormClient implements IBatchDefaultsIncentivesFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBatchDefaultsIncentivesForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsIncentivesForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/incentives";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBatchDefaultsIncentivesForm(_response);
        });
    }

    protected processGetBatchDefaultsIncentivesForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsIncentivesForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsIncentivesForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsIncentivesForm>(null as any);
    }

    saveBatchDefaultsIncentivesForm(batchId: string, batchDefaultsIncentivesForm: BatchDefaultsIncentivesForm): Promise<ResponsePayloadOfBatchDefaultsIncentivesForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/incentives";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(batchDefaultsIncentivesForm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBatchDefaultsIncentivesForm(_response);
        });
    }

    protected processSaveBatchDefaultsIncentivesForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsIncentivesForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsIncentivesForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsIncentivesForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsIncentivesForm>(null as any);
    }
}

export interface IBatchDefaultsHousingAuthorityScalingFormClient {

    getBatchDefaultsHousingAuthorityScalingForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsHousingAuthorityScalingForm>;

    saveBatchDefaultsHousingAuthorityScalingForm(batchId: string, batchDefaultsHousingAuthorityScalingForm: BatchDefaultsHousingAuthorityScalingForm): Promise<ResponsePayloadOfBatchDefaultsHousingAuthorityScalingForm>;
}

export class BatchDefaultsHousingAuthorityScalingFormClient implements IBatchDefaultsHousingAuthorityScalingFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBatchDefaultsHousingAuthorityScalingForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsHousingAuthorityScalingForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/housing-authority-scaling";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBatchDefaultsHousingAuthorityScalingForm(_response);
        });
    }

    protected processGetBatchDefaultsHousingAuthorityScalingForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsHousingAuthorityScalingForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsHousingAuthorityScalingForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsHousingAuthorityScalingForm>(null as any);
    }

    saveBatchDefaultsHousingAuthorityScalingForm(batchId: string, batchDefaultsHousingAuthorityScalingForm: BatchDefaultsHousingAuthorityScalingForm): Promise<ResponsePayloadOfBatchDefaultsHousingAuthorityScalingForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/housing-authority-scaling";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(batchDefaultsHousingAuthorityScalingForm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBatchDefaultsHousingAuthorityScalingForm(_response);
        });
    }

    protected processSaveBatchDefaultsHousingAuthorityScalingForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsHousingAuthorityScalingForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsHousingAuthorityScalingForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsHousingAuthorityScalingForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsHousingAuthorityScalingForm>(null as any);
    }
}

export interface IBatchDefaultsGtlAndLtlFormClient {

    getBatchDefaultsGtlAndLtlForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsGtlAndLtlForm>;

    saveBatchDefaultsGtlAndLtlForm(batchId: string, batchDefaultsGtlAndLtlForm: BatchDefaultsGtlAndLtlForm): Promise<ResponsePayloadOfBatchDefaultsGtlAndLtlForm>;
}

export class BatchDefaultsGtlAndLtlFormClient implements IBatchDefaultsGtlAndLtlFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBatchDefaultsGtlAndLtlForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsGtlAndLtlForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/gtl-and-ltl-form";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBatchDefaultsGtlAndLtlForm(_response);
        });
    }

    protected processGetBatchDefaultsGtlAndLtlForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsGtlAndLtlForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsGtlAndLtlForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsGtlAndLtlForm>(null as any);
    }

    saveBatchDefaultsGtlAndLtlForm(batchId: string, batchDefaultsGtlAndLtlForm: BatchDefaultsGtlAndLtlForm): Promise<ResponsePayloadOfBatchDefaultsGtlAndLtlForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/gtl-and-ltl";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(batchDefaultsGtlAndLtlForm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBatchDefaultsGtlAndLtlForm(_response);
        });
    }

    protected processSaveBatchDefaultsGtlAndLtlForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsGtlAndLtlForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsGtlAndLtlForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsGtlAndLtlForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsGtlAndLtlForm>(null as any);
    }
}

export interface IBatchDefaultsGrowthRatesFormClient {

    getBatchDefaultsGrowthRatesForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsGrowthRatesForm>;

    saveBatchDefaultsGrowthRatesForm(batchId: string, batchDefaultsGrowthRatesForm: BatchDefaultsGrowthRatesForm): Promise<ResponsePayloadOfBatchDefaultsGrowthRatesForm>;
}

export class BatchDefaultsGrowthRatesFormClient implements IBatchDefaultsGrowthRatesFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBatchDefaultsGrowthRatesForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsGrowthRatesForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/growth-rate-form";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBatchDefaultsGrowthRatesForm(_response);
        });
    }

    protected processGetBatchDefaultsGrowthRatesForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsGrowthRatesForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsGrowthRatesForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsGrowthRatesForm>(null as any);
    }

    saveBatchDefaultsGrowthRatesForm(batchId: string, batchDefaultsGrowthRatesForm: BatchDefaultsGrowthRatesForm): Promise<ResponsePayloadOfBatchDefaultsGrowthRatesForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/growth-rates";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(batchDefaultsGrowthRatesForm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBatchDefaultsGrowthRatesForm(_response);
        });
    }

    protected processSaveBatchDefaultsGrowthRatesForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsGrowthRatesForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsGrowthRatesForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsGrowthRatesForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsGrowthRatesForm>(null as any);
    }
}

export interface IBatchDefaultsExportTermsFormClient {

    getBatchDefaultsExportTermsForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsExportTermsForm>;

    saveBatchDefaultsExportTermsForm(batchId: string, batchDefaultsExportTermsForm: BatchDefaultsExportTermsForm): Promise<ResponsePayloadOfBatchDefaultsExportTermsForm>;
}

export class BatchDefaultsExportTermsFormClient implements IBatchDefaultsExportTermsFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBatchDefaultsExportTermsForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsExportTermsForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/export-terms";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBatchDefaultsExportTermsForm(_response);
        });
    }

    protected processGetBatchDefaultsExportTermsForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsExportTermsForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsExportTermsForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsExportTermsForm>(null as any);
    }

    saveBatchDefaultsExportTermsForm(batchId: string, batchDefaultsExportTermsForm: BatchDefaultsExportTermsForm): Promise<ResponsePayloadOfBatchDefaultsExportTermsForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/export-terms";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(batchDefaultsExportTermsForm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBatchDefaultsExportTermsForm(_response);
        });
    }

    protected processSaveBatchDefaultsExportTermsForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsExportTermsForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsExportTermsForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsExportTermsForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsExportTermsForm>(null as any);
    }
}

export interface IBatchDefaultsExceptionsFormClient {

    getBatchDefaultsExceptionsForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsExceptionsForm>;

    saveBatchDefaultsExceptionsForm(batchId: string, batchDefaultsExceptionsForm: BatchDefaultsExceptionsForm): Promise<ResponsePayloadOfBatchDefaultsExceptionsForm>;
}

export class BatchDefaultsExceptionsFormClient implements IBatchDefaultsExceptionsFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBatchDefaultsExceptionsForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsExceptionsForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/exceptions";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBatchDefaultsExceptionsForm(_response);
        });
    }

    protected processGetBatchDefaultsExceptionsForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsExceptionsForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsExceptionsForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsExceptionsForm>(null as any);
    }

    saveBatchDefaultsExceptionsForm(batchId: string, batchDefaultsExceptionsForm: BatchDefaultsExceptionsForm): Promise<ResponsePayloadOfBatchDefaultsExceptionsForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/exceptions";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(batchDefaultsExceptionsForm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBatchDefaultsExceptionsForm(_response);
        });
    }

    protected processSaveBatchDefaultsExceptionsForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsExceptionsForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsExceptionsForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsExceptionsForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsExceptionsForm>(null as any);
    }
}

export interface IBatchDefaultsBmrFormClient {

    getBatchDefaultsBmrForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsBmrForm>;

    saveBatchDefaultsBmrForm(batchId: string, batchDefaultsBmrForm: BatchDefaultsBmrForm): Promise<ResponsePayloadOfBatchDefaultsBmrForm>;
}

export class BatchDefaultsBmrFormClient implements IBatchDefaultsBmrFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBatchDefaultsBmrForm(batchId: string): Promise<ResponsePayloadOfBatchDefaultsBmrForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/bmr";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBatchDefaultsBmrForm(_response);
        });
    }

    protected processGetBatchDefaultsBmrForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsBmrForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsBmrForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsBmrForm>(null as any);
    }

    saveBatchDefaultsBmrForm(batchId: string, batchDefaultsBmrForm: BatchDefaultsBmrForm): Promise<ResponsePayloadOfBatchDefaultsBmrForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/bmr";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(batchDefaultsBmrForm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBatchDefaultsBmrForm(_response);
        });
    }

    protected processSaveBatchDefaultsBmrForm(response: Response): Promise<ResponsePayloadOfBatchDefaultsBmrForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsBmrForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBatchDefaultsBmrForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBatchDefaultsBmrForm>(null as any);
    }
}

export interface IBaselineDefaultsRenewalNoticePeriodFormClient {

    getBaselineDefaultsRenewalNoticePeriodForm(): Promise<ResponsePayloadOfBaselineDefaultsRenewalNoticePeriodForm>;

    saveBaselineDefaultsRenewalNoticePeriodForm(form: BaselineDefaultsRenewalNoticePeriodForm): Promise<ResponsePayloadOfBaselineDefaultsRenewalNoticePeriodForm>;
}

export class BaselineDefaultsRenewalNoticePeriodFormClient implements IBaselineDefaultsRenewalNoticePeriodFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBaselineDefaultsRenewalNoticePeriodForm(): Promise<ResponsePayloadOfBaselineDefaultsRenewalNoticePeriodForm> {
        let url_ = this.baseUrl + "/baselinedefaults/renewal-notice-period";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBaselineDefaultsRenewalNoticePeriodForm(_response);
        });
    }

    protected processGetBaselineDefaultsRenewalNoticePeriodForm(response: Response): Promise<ResponsePayloadOfBaselineDefaultsRenewalNoticePeriodForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsRenewalNoticePeriodForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBaselineDefaultsRenewalNoticePeriodForm>(null as any);
    }

    saveBaselineDefaultsRenewalNoticePeriodForm(form: BaselineDefaultsRenewalNoticePeriodForm): Promise<ResponsePayloadOfBaselineDefaultsRenewalNoticePeriodForm> {
        let url_ = this.baseUrl + "/baselinedefaults/renewal-notice-period";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBaselineDefaultsRenewalNoticePeriodForm(_response);
        });
    }

    protected processSaveBaselineDefaultsRenewalNoticePeriodForm(response: Response): Promise<ResponsePayloadOfBaselineDefaultsRenewalNoticePeriodForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsRenewalNoticePeriodForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsRenewalNoticePeriodForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBaselineDefaultsRenewalNoticePeriodForm>(null as any);
    }
}

export interface IBaselineDefaultsRegulationsFormClient {

    getBaselineDefaultsRegulationsForm(): Promise<ResponsePayloadOfBaselineDefaultsRegulationsForm>;

    saveBaselineDefaultsRegulationsForm(form: BaselineDefaultsRegulationsForm): Promise<ResponsePayloadOfBaselineDefaultsRegulationsForm>;
}

export class BaselineDefaultsRegulationsFormClient implements IBaselineDefaultsRegulationsFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBaselineDefaultsRegulationsForm(): Promise<ResponsePayloadOfBaselineDefaultsRegulationsForm> {
        let url_ = this.baseUrl + "/baselinedefaults/regulations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBaselineDefaultsRegulationsForm(_response);
        });
    }

    protected processGetBaselineDefaultsRegulationsForm(response: Response): Promise<ResponsePayloadOfBaselineDefaultsRegulationsForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsRegulationsForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBaselineDefaultsRegulationsForm>(null as any);
    }

    saveBaselineDefaultsRegulationsForm(form: BaselineDefaultsRegulationsForm): Promise<ResponsePayloadOfBaselineDefaultsRegulationsForm> {
        let url_ = this.baseUrl + "/baselinedefaults/regulations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBaselineDefaultsRegulationsForm(_response);
        });
    }

    protected processSaveBaselineDefaultsRegulationsForm(response: Response): Promise<ResponsePayloadOfBaselineDefaultsRegulationsForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsRegulationsForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsRegulationsForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBaselineDefaultsRegulationsForm>(null as any);
    }
}

export interface IBaselineDefaultsExportTermsFormClient {

    getBaselineDefaultsExportTermsForm(): Promise<ResponsePayloadOfBaselineDefaultsExportTermsForm>;

    saveBaselineDefaultsExportTermsForm(form: BaselineDefaultsExportTermsForm): Promise<ResponsePayloadOfBaselineDefaultsExportTermsForm>;
}

export class BaselineDefaultsExportTermsFormClient implements IBaselineDefaultsExportTermsFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBaselineDefaultsExportTermsForm(): Promise<ResponsePayloadOfBaselineDefaultsExportTermsForm> {
        let url_ = this.baseUrl + "/baselinedefaults/export-terms";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBaselineDefaultsExportTermsForm(_response);
        });
    }

    protected processGetBaselineDefaultsExportTermsForm(response: Response): Promise<ResponsePayloadOfBaselineDefaultsExportTermsForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsExportTermsForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBaselineDefaultsExportTermsForm>(null as any);
    }

    saveBaselineDefaultsExportTermsForm(form: BaselineDefaultsExportTermsForm): Promise<ResponsePayloadOfBaselineDefaultsExportTermsForm> {
        let url_ = this.baseUrl + "/baselinedefaults/export-terms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBaselineDefaultsExportTermsForm(_response);
        });
    }

    protected processSaveBaselineDefaultsExportTermsForm(response: Response): Promise<ResponsePayloadOfBaselineDefaultsExportTermsForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsExportTermsForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsExportTermsForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBaselineDefaultsExportTermsForm>(null as any);
    }
}

export interface IBaselineDefaultsHousingAuthorityScalingFormClient {

    getBaselineDefaultsHousingAuthorityScalingForm(): Promise<ResponsePayloadOfBaselineDefaultsHousingAuthorityScalingForm>;

    saveBaselineDefaultsHousingAuthorityScalingForm(form: BaselineDefaultsHousingAuthorityScalingForm): Promise<ResponsePayloadOfBaselineDefaultsHousingAuthorityScalingForm>;
}

export class BaselineDefaultsHousingAuthorityScalingFormClient implements IBaselineDefaultsHousingAuthorityScalingFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBaselineDefaultsHousingAuthorityScalingForm(): Promise<ResponsePayloadOfBaselineDefaultsHousingAuthorityScalingForm> {
        let url_ = this.baseUrl + "/baselinedefaults/housing-authority-scaling";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBaselineDefaultsHousingAuthorityScalingForm(_response);
        });
    }

    protected processGetBaselineDefaultsHousingAuthorityScalingForm(response: Response): Promise<ResponsePayloadOfBaselineDefaultsHousingAuthorityScalingForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsHousingAuthorityScalingForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBaselineDefaultsHousingAuthorityScalingForm>(null as any);
    }

    saveBaselineDefaultsHousingAuthorityScalingForm(form: BaselineDefaultsHousingAuthorityScalingForm): Promise<ResponsePayloadOfBaselineDefaultsHousingAuthorityScalingForm> {
        let url_ = this.baseUrl + "/baselinedefaults/housing-authority-scaling";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBaselineDefaultsHousingAuthorityScalingForm(_response);
        });
    }

    protected processSaveBaselineDefaultsHousingAuthorityScalingForm(response: Response): Promise<ResponsePayloadOfBaselineDefaultsHousingAuthorityScalingForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsHousingAuthorityScalingForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsHousingAuthorityScalingForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBaselineDefaultsHousingAuthorityScalingForm>(null as any);
    }
}

export interface IBaselineDefaultsIncentivesFormClient {

    getBaselineDefaultsIncentivesForm(): Promise<ResponsePayloadOfBaselineDefaultsIncentivesForm>;

    saveBaselineDefaultsIncentivesForm(form: BaselineDefaultsIncentivesForm): Promise<ResponsePayloadOfBaselineDefaultsIncentivesForm>;
}

export class BaselineDefaultsIncentivesFormClient implements IBaselineDefaultsIncentivesFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBaselineDefaultsIncentivesForm(): Promise<ResponsePayloadOfBaselineDefaultsIncentivesForm> {
        let url_ = this.baseUrl + "/baselinedefaults/incentives";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBaselineDefaultsIncentivesForm(_response);
        });
    }

    protected processGetBaselineDefaultsIncentivesForm(response: Response): Promise<ResponsePayloadOfBaselineDefaultsIncentivesForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsIncentivesForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBaselineDefaultsIncentivesForm>(null as any);
    }

    saveBaselineDefaultsIncentivesForm(form: BaselineDefaultsIncentivesForm): Promise<ResponsePayloadOfBaselineDefaultsIncentivesForm> {
        let url_ = this.baseUrl + "/baselinedefaults/incentives";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBaselineDefaultsIncentivesForm(_response);
        });
    }

    protected processSaveBaselineDefaultsIncentivesForm(response: Response): Promise<ResponsePayloadOfBaselineDefaultsIncentivesForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsIncentivesForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsIncentivesForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBaselineDefaultsIncentivesForm>(null as any);
    }
}

export interface IBaselineDefaultsRentControlFormClient {

    getBaselineDefaultsRentControlForm(): Promise<ResponsePayloadOfBaselineDefaultsRentControlForm>;

    saveBaselineDefaultsRentControlForm(form: BaselineDefaultsRentControlForm): Promise<ResponsePayloadOfBaselineDefaultsRentControlForm>;
}

export class BaselineDefaultsRentControlFormClient implements IBaselineDefaultsRentControlFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBaselineDefaultsRentControlForm(): Promise<ResponsePayloadOfBaselineDefaultsRentControlForm> {
        let url_ = this.baseUrl + "/baselinedefaults/rent-control";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBaselineDefaultsRentControlForm(_response);
        });
    }

    protected processGetBaselineDefaultsRentControlForm(response: Response): Promise<ResponsePayloadOfBaselineDefaultsRentControlForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsRentControlForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBaselineDefaultsRentControlForm>(null as any);
    }

    saveBaselineDefaultsRentControlForm(form: BaselineDefaultsRentControlForm): Promise<ResponsePayloadOfBaselineDefaultsRentControlForm> {
        let url_ = this.baseUrl + "/baselinedefaults/rent-control";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBaselineDefaultsRentControlForm(_response);
        });
    }

    protected processSaveBaselineDefaultsRentControlForm(response: Response): Promise<ResponsePayloadOfBaselineDefaultsRentControlForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsRentControlForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsRentControlForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBaselineDefaultsRentControlForm>(null as any);
    }
}

export interface IBaselineDefaultsScalingFormClient {

    getBaselineDefaultsScalingForm(): Promise<ResponsePayloadOfBaselineDefaultsScalingForm>;

    saveBaselineDefaultsScalingForm(form: BaselineDefaultsScalingForm): Promise<ResponsePayloadOfBaselineDefaultsScalingForm>;
}

export class BaselineDefaultsScalingFormClient implements IBaselineDefaultsScalingFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBaselineDefaultsScalingForm(): Promise<ResponsePayloadOfBaselineDefaultsScalingForm> {
        let url_ = this.baseUrl + "/baselinedefaults/scaling";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBaselineDefaultsScalingForm(_response);
        });
    }

    protected processGetBaselineDefaultsScalingForm(response: Response): Promise<ResponsePayloadOfBaselineDefaultsScalingForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsScalingForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBaselineDefaultsScalingForm>(null as any);
    }

    saveBaselineDefaultsScalingForm(form: BaselineDefaultsScalingForm): Promise<ResponsePayloadOfBaselineDefaultsScalingForm> {
        let url_ = this.baseUrl + "/baselinedefaults/scaling";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBaselineDefaultsScalingForm(_response);
        });
    }

    protected processSaveBaselineDefaultsScalingForm(response: Response): Promise<ResponsePayloadOfBaselineDefaultsScalingForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsScalingForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsScalingForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBaselineDefaultsScalingForm>(null as any);
    }
}

export interface IRentControlTypesFormClient {

    getRentControlTypesForm(): Promise<ResponsePayloadOfRentControlTypesForm>;

    saveRentControlTypesForm(form: RentControlTypesForm): Promise<ResponsePayloadOfRentControlTypesForm>;
}

export class RentControlTypesFormClient implements IRentControlTypesFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getRentControlTypesForm(): Promise<ResponsePayloadOfRentControlTypesForm> {
        let url_ = this.baseUrl + "/baselinedefaults/rent-control-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRentControlTypesForm(_response);
        });
    }

    protected processGetRentControlTypesForm(response: Response): Promise<ResponsePayloadOfRentControlTypesForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfRentControlTypesForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfRentControlTypesForm>(null as any);
    }

    saveRentControlTypesForm(form: RentControlTypesForm): Promise<ResponsePayloadOfRentControlTypesForm> {
        let url_ = this.baseUrl + "/baselinedefaults/rent-control-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveRentControlTypesForm(_response);
        });
    }

    protected processSaveRentControlTypesForm(response: Response): Promise<ResponsePayloadOfRentControlTypesForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfRentControlTypesForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfRentControlTypesForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfRentControlTypesForm>(null as any);
    }
}

export interface IBaselineDefaultsExceptionsFormClient {

    getBaselineDefaultsExceptionsForm(): Promise<ResponsePayloadOfBaselineDefaultsExceptionsForm>;

    saveBaselineDefaultsExceptionsForm(form: BaselineDefaultsExceptionsForm): Promise<ResponsePayloadOfBaselineDefaultsExceptionsForm>;
}

export class BaselineDefaultsExceptionsFormClient implements IBaselineDefaultsExceptionsFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBaselineDefaultsExceptionsForm(): Promise<ResponsePayloadOfBaselineDefaultsExceptionsForm> {
        let url_ = this.baseUrl + "/baselinedefaults/exceptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBaselineDefaultsExceptionsForm(_response);
        });
    }

    protected processGetBaselineDefaultsExceptionsForm(response: Response): Promise<ResponsePayloadOfBaselineDefaultsExceptionsForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsExceptionsForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBaselineDefaultsExceptionsForm>(null as any);
    }

    saveBaselineDefaultsExceptionsForm(form: BaselineDefaultsExceptionsForm): Promise<ResponsePayloadOfBaselineDefaultsExceptionsForm> {
        let url_ = this.baseUrl + "/baselinedefaults/exceptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBaselineDefaultsExceptionsForm(_response);
        });
    }

    protected processSaveBaselineDefaultsExceptionsForm(response: Response): Promise<ResponsePayloadOfBaselineDefaultsExceptionsForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsExceptionsForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsExceptionsForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBaselineDefaultsExceptionsForm>(null as any);
    }
}

export interface IBaselineDefaultsBmrFormClient {

    getBaselineDefaultsBmrForm(): Promise<ResponsePayloadOfBaselineDefaultsBmrForm>;

    saveBaselineDefaultsBmrForm(form: BaselineDefaultsBmrForm): Promise<ResponsePayloadOfBaselineDefaultsBmrForm>;
}

export class BaselineDefaultsBmrFormClient implements IBaselineDefaultsBmrFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBaselineDefaultsBmrForm(): Promise<ResponsePayloadOfBaselineDefaultsBmrForm> {
        let url_ = this.baseUrl + "/baselinedefaults/bmr";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBaselineDefaultsBmrForm(_response);
        });
    }

    protected processGetBaselineDefaultsBmrForm(response: Response): Promise<ResponsePayloadOfBaselineDefaultsBmrForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsBmrForm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBaselineDefaultsBmrForm>(null as any);
    }

    saveBaselineDefaultsBmrForm(form: BaselineDefaultsBmrForm): Promise<ResponsePayloadOfBaselineDefaultsBmrForm> {
        let url_ = this.baseUrl + "/baselinedefaults/bmr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBaselineDefaultsBmrForm(_response);
        });
    }

    protected processSaveBaselineDefaultsBmrForm(response: Response): Promise<ResponsePayloadOfBaselineDefaultsBmrForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsBmrForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfBaselineDefaultsBmrForm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfBaselineDefaultsBmrForm>(null as any);
    }
}

export interface IActualResultsSummaryFormClient {

    getForm(batchId: string): Promise<ResponsePayloadOfActualResultsSummaryForm>;

    getFormForFilters(batchId: string, form: ActualResultsSummaryForm): Promise<ResponsePayloadOfActualResultsSummaryForm>;
}

export class ActualResultsSummaryFormClient implements IActualResultsSummaryFormClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getForm(batchId: string): Promise<ResponsePayloadOfActualResultsSummaryForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/actual-results-summary";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetForm(_response);
        });
    }

    protected processGetForm(response: Response): Promise<ResponsePayloadOfActualResultsSummaryForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfActualResultsSummaryForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfActualResultsSummaryForm;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfActualResultsSummaryForm>(null as any);
    }

    getFormForFilters(batchId: string, form: ActualResultsSummaryForm): Promise<ResponsePayloadOfActualResultsSummaryForm> {
        let url_ = this.baseUrl + "/batches/{batchId}/actual-results-summary";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFormForFilters(_response);
        });
    }

    protected processGetFormForFilters(response: Response): Promise<ResponsePayloadOfActualResultsSummaryForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfActualResultsSummaryForm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponsePayloadOfActualResultsSummaryForm;
            return throwException("Validation failed", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponsePayloadOfActualResultsSummaryForm>(null as any);
    }
}

export interface ResponsePayloadOfUserForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: UserForm | undefined;
}

export enum UserRoleKind {
    UserAdmin = 0,
    RevenueManager = 1,
    CommunityManager = 2,
    RegionalPortfolioManager = 3,
    DivisionManager = 4,
}

export interface UserPermissions {
    canViewBatchListForm?: boolean;
    canViewBestRenewalOffersForm?: boolean;
    canCreateBatch?: boolean;
    canViewEditComments?: boolean;
    canViewUserAdminForm?: boolean;
    canAddEditDeleteUser?: boolean;
    canViewBatchDefaultsForms?: boolean;
    canAddEditBatchDefaultsForms?: boolean;
    canViewBaselineDefaultsForms?: boolean;
    canAddEditBaselineDefaultsForms?: boolean;
    canApproveAndRejectBestRenewalOffersForm?: boolean;
    canViewReviewSummaryForm?: boolean;
    canApproveAndRejectReviewSummaryForm?: boolean;
    prefersSummaryView?: boolean;
    canViewBestRenewalOffersActualsForm?: boolean;
    canViewRenewalFollowUpForm?: boolean;
    canViewActualResultsSummaryForm?: boolean;
}

export interface Validatable {
    formValidationErrors?: string[];
    fieldValidationErrors?: { [key: string]: string; };
    isValid?: boolean;
}

export interface UserForm extends Validatable {
    key?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    roles?: UserFormRole[];
    selectedRole?: UserFormRole | undefined;
}

export interface UserFormRole {
    key?: string | undefined;
    displayValue?: string | undefined;
    divisions?: UserFormDivision[];
    selectedDivisions?: UserFormDivision[];
    userFormConfiguration?: UserFormConfiguration;
}

export interface UserFormDivision {
    key?: string | undefined;
    displayValue?: string | undefined;
    properties?: UserFormProperty[];
    selectedProperties?: UserFormProperty[];
}

export interface UserFormProperty {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface UserFormConfiguration {
    hideDivision?: boolean;
    hideProperties?: boolean;
    enableDivisionMultiselect?: boolean;
    divisionLabelName?: string | undefined;
}

export interface ResponsePayloadOfUserAdminForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: UserAdminForm | undefined;
}

export interface UserAdminForm {
    divisions?: UserAdminFormDivision[];
    selectedDivision?: UserAdminFormDivision | undefined;
    roles?: UserAdminFormRole[];
    selectedRole?: UserAdminFormRole | undefined;
    users?: UserAdminFormUser[];
}

export interface UserAdminFormDivision {
    key?: string | undefined;
    displayValue?: string | undefined;
    properties?: UserAdminFormProperty[];
    selectedProperty?: UserAdminFormProperty | undefined;
}

export interface UserAdminFormProperty {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface UserAdminFormRole {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface UserAdminFormUser {
    key?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    role?: string | undefined;
    division?: string | undefined;
    propertyCount?: string | undefined;
    properties?: UserAdminFormProperty[];
}

export interface ResponsePayloadOfSite {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: Site | undefined;
}

export interface Site {
}

export interface ResponsePayloadOfReviewSummaryForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: ReviewSummaryForm | undefined;
}

export interface ReviewSummaryForm extends Validatable {
    batchDetail?: BatchDetail | undefined;
    batchComments?: BestRenewalOffersFormBatchComments;
    filters?: ReviewSummaryFormFilters | undefined;
    countySummary?: CommonSummaryFormSummary | undefined;
    propertySummary?: CommonSummaryFormSummary | undefined;
    unitSummary?: CommonSummaryFormSummary | undefined;
    activeView?: CommonSummaryRollupKind;
    totalBatchPropertyCount?: number | undefined;
    rejectReason?: string;
    pageConfiguration?: ReviewSummaryPageConfiguration;
    navigationConfiguration?: BatchNavigationConfiguration;
}

export interface BatchDetail {
    key?: string | undefined;
    division?: string | undefined;
    batchTypes?: BatchDetailBatchType[];
    startDate?: string | undefined;
    endDate?: string | undefined;
    version?: string | undefined;
    status?: string | undefined;
    statusKey?: string | undefined;
    lastUpdatedDate?: string | undefined;
}

export interface BatchDetailBatchType {
    key?: string | undefined;
    batchTypeKind?: BatchTypeKind;
    displayValue?: string | undefined;
}

export enum BatchTypeKind {
    Conventional = 0,
    ShortTermConventional = 1,
    BelowMarketRent = 2,
    RentControl = 3,
    ShortTermRentControl = 4,
    OneOff = 5,
}

export interface BestRenewalOffersFormBatchComments {
    totalCount?: number;
    approvalReasons?: BestRenewalOffersFormComment[];
    propertyComments?: BestRenewalOffersFormPropertyComments[];
    unitCommentsByProperty?: BestRenewalOffersFormUnitCommentsByProperty[];
}

export interface BestRenewalOffersFormComment extends Validatable {
    id?: number;
    author?: string | undefined;
    isMyComment?: boolean;
    timestamp?: Date;
    text?: string;
    propertyName?: string;
    propertyKey?: string | undefined;
    unitName?: string;
    unitKey?: string | undefined;
}

export interface BestRenewalOffersFormPropertyComments {
    name?: string;
    comments?: BestRenewalOffersFormComment[];
}

export interface BestRenewalOffersFormUnitCommentsByProperty {
    propertyName?: string;
    unitComments?: BestRenewalOffersFormUnitComments[];
}

export interface BestRenewalOffersFormUnitComments {
    propertyName?: string;
    unitName?: string;
    comments?: BestRenewalOffersFormComment[];
}

export interface ReviewSummaryFormFilters {
    countyFilters?: ReviewSummaryFormFilter[];
    selectedCountyFilter?: ReviewSummaryFormFilter | undefined;
    propertyFilters?: ReviewSummaryFormFilter[];
    selectedPropertyFilter?: ReviewSummaryFormFilter | undefined;
    bedroomFilters?: ReviewSummaryFormFilter[];
    selectedBedroomFilter?: ReviewSummaryFormFilter | undefined;
    rpmFilters?: ReviewSummaryFormFilter[];
    selectedRpmFilter?: ReviewSummaryFormFilter | undefined;
    isExcludedFilters?: ReviewSummaryFormFilter[];
    selectedIsExcludedFilter?: ReviewSummaryFormFilter | undefined;
    onlyHasExceptionsFilter?: boolean | undefined;
}

export interface ReviewSummaryFormFilter {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface CommonSummaryFormSummary {
    rollups?: CommonSummaryFormRollup[];
    rollupTotals?: CommonSummaryFormRollup | undefined;
}

export interface CommonSummaryFormRollup {
    key?: string | undefined;
    county?: string | undefined;
    property?: string | undefined;
    rpm?: string | undefined;
    countyKey?: string | undefined;
    propertyKey?: string | undefined;
    propertyComments?: CommonSummaryFormComment[] | undefined;
    unit?: string | undefined;
    unitComments?: CommonSummaryFormComment[] | undefined;
    renewals?: string | undefined;
    currentRentDollars?: string | undefined;
    marketRentDollars?: string | undefined;
    adjustedMarketRentDollars?: string | undefined;
    bestOfferDollars?: string | undefined;
    averageIncreasePercentage?: string | undefined;
    averageIncreaseDollars?: string | undefined;
    offerToAdjustedMarketRentDollars?: string | undefined;
    offerToAdjustedMarketRentPercentage?: string | undefined;
    isSelected?: boolean | undefined;
    isUnitException?: boolean | undefined;
    isPropertyException?: boolean | undefined;
    averageRecurringConcession?: string | undefined;
    netEffectiveAdjustedMarketRentPercentage?: string | undefined;
    netEffectiveIncreasePercentage?: string | undefined;
}

export interface CommonSummaryFormComment extends Validatable {
    id?: number;
    author?: string | undefined;
    isMyComment?: boolean;
    timestamp?: Date;
    text?: string;
    propertyName?: string;
    unitName?: string;
    propertyKey?: string | undefined;
    unitKey?: string | undefined;
}

export enum CommonSummaryRollupKind {
    County = 0,
    Property = 1,
    Unit = 2,
}

export interface ReviewSummaryPageConfiguration {
    isApprovalEnabled?: boolean;
}

export interface BatchNavigationConfiguration {
    showActualResults?: boolean;
    showActualResultsSummary?: boolean;
    showRenewalFollowUp?: boolean;
    showBatchDefaults?: boolean;
}

export interface ResponsePayloadOfListOfCommonSummaryFormComment {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: CommonSummaryFormComment[] | undefined;
}

export interface ResponsePayloadOfCommonSummaryFormComment {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: CommonSummaryFormComment | undefined;
}

export interface ResponsePayloadOfRenewalFollowUpForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: RenewalFollowUpForm | undefined;
}

export interface RenewalFollowUpForm {
    batchDetail?: BatchDetail | undefined;
    filters?: RenewalFollowUpFormFilters | undefined;
    rollups?: RenewalFollowUpFormRollup[];
    rollupTotals?: RenewalFollowUpFormRollup | undefined;
    navigationConfiguration?: BatchNavigationConfiguration | undefined;
}

export interface RenewalFollowUpFormFilters {
    rpmFilters?: RenewalFollowUpFormFilter[];
    selectedRpmFilter?: RenewalFollowUpFormFilter | undefined;
}

export interface RenewalFollowUpFormFilter {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface RenewalFollowUpFormRollup {
    propertyName?: string | undefined;
    totalCount?: string | undefined;
    renewedCount?: string | undefined;
    noticeToVacateCount?: string | undefined;
    monthToMonthCount?: string | undefined;
    transferCount?: string | undefined;
    toBeDeterminedCount?: string | undefined;
    averageDaysToFinalizeRenewals?: string | undefined;
    averageDaysToFinalizeNoticeToVacate?: string | undefined;
    renewalsWithinGoalPercentage?: string | undefined;
    noticeToVacateWithinGoalPercentage?: string | undefined;
    averageDeviationFromOfferDollars?: string | undefined;
}

export interface ResponsePayloadOfAtlasHelpFormDownload {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: AtlasHelpFormDownload | undefined;
}

export interface AtlasHelpFormDownload {
    fileLocation?: string;
}

export interface ResponsePayloadOfDefaultsAdminGtlAndLtlForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: DefaultsAdminGtlAndLtlForm | undefined;
}

export interface DefaultsAdminGtlAndLtlForm extends Validatable {
    divisions?: DefaultsAdminGtlAndLtlFormDivision[];
    selectedDivision?: DefaultsAdminGtlAndLtlFormDivision | undefined;
    pageConfiguration?: DefaultsPageConfiguration | undefined;
}

export interface DefaultsAdminGtlAndLtlFormDivision {
    key?: string | undefined;
    displayValue?: string | undefined;
    bedroomTypesForBedroomDefaults?: DefaultsAdminGtlAndLtlFormBedroomType[];
    bedroomTypesForPropertyBedroomDefaults?: DefaultsAdminGtlAndLtlFormBedroomType[];
    calculationMethodTypes?: DefaultsAdminGtlAndLtlFormCalculationMethodType[];
    propertyTypes?: DefaultsAdminGtlAndLtlFormPropertyType[];
    defaultsDropRateRangeDefaults?: BaselineDefaultsGtlAndLtlFormDropRateDefaults | undefined;
    defaults?: DefaultsAdminGtlAndLtlFormDefaults | undefined;
    bedroomDropRateRangeDefaults?: BaselineDefaultsGtlAndLtlFormDropRateDefaults | undefined;
    bedroomDefaults?: DefaultsAdminGtlAndLtlFormDefaults[];
    propertyBedroomDropRateRangeDefaults?: BaselineDefaultsGtlAndLtlFormDropRateDefaults | undefined;
    propertyBedroomDefaults?: DefaultsAdminGtlAndLtlFormDefaults[];
    isChanged?: boolean;
}

export interface DefaultsAdminGtlAndLtlFormBedroomType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface DefaultsAdminGtlAndLtlFormCalculationMethodType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface DefaultsAdminGtlAndLtlFormPropertyType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsGtlAndLtlFormDropRateDefaults extends Validatable {
    ranges?: BaselineDefaultsGtlAndLtlFormDropRateRanges | undefined;
    isEnabled?: boolean;
}

export interface BaselineDefaultsGtlAndLtlFormDropRateRanges extends Validatable {
    dropRateOneRange?: BaselineDefaultsGtlAndLtlFormDropRateDefaultsRange | undefined;
    dropRateTwoRange?: BaselineDefaultsGtlAndLtlFormDropRateDefaultsRange | undefined;
    dropRateThreeRange?: BaselineDefaultsGtlAndLtlFormDropRateDefaultsRange | undefined;
}

export interface BaselineDefaultsGtlAndLtlFormDropRateDefaultsRange extends Validatable {
    label?: string | undefined;
    bottomRange?: string | undefined;
    topRange?: string | undefined;
}

export interface DefaultsAdminGtlAndLtlFormDefaults extends Validatable {
    essexMaxPercentage?: string | undefined;
    ltlRecapPercentage?: string | undefined;
    minPercentage?: string | undefined;
    maxPercentage?: string | undefined;
    netEffectiveMaxPercentage?: string | undefined;
    gtlRecapPercentage?: string | undefined;
    dropRate1Percentage?: string | undefined;
    dropRate2Percentage?: string | undefined;
    dropRate3Percentage?: string | undefined;
    selectedPropertyType?: DefaultsAdminGtlAndLtlFormPropertyType | undefined;
    selectedBedroomType?: DefaultsAdminGtlAndLtlFormBedroomType | undefined;
    calculationMethodType?: DefaultsAdminGtlAndLtlFormCalculationMethodType | undefined;
}

export interface DefaultsPageConfiguration {
    isEditEnabled?: boolean;
}

export interface ResponsePayloadOfDefaultsAdminGrowthRatesForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: DefaultsAdminGrowthRatesForm | undefined;
}

export interface DefaultsAdminGrowthRatesForm extends Validatable {
    divisions?: DefaultsAdminGrowthRatesFormDivision[];
    selectedDivision?: DefaultsAdminGrowthRatesFormDivision | undefined;
    pageConfiguration?: DefaultsPageConfiguration | undefined;
}

export interface DefaultsAdminGrowthRatesFormDivision extends Validatable {
    key?: string | undefined;
    displayValue?: string | undefined;
    bedroomTypesForBedroomDefaults?: DefaultsAdminGrowthRatesFormBedroomType[];
    bedroomTypesForPropertyBedroomDefaults?: DefaultsAdminGrowthRatesFormBedroomType[];
    propertyTypes?: DefaultsAdminGrowthRatesFormPropertyType[];
    countyTypes?: KeyDisplayValue[];
    defaultPercentage?: string | undefined;
    bedroomRateDefaults?: DefaultsAdminGrowthRatesFormBedroom[];
    propertyBedroomRateDefaults?: DefaultsAdminGrowthRatesFormPropertyBedroom[];
    countyBedroomRateDefaults?: DefaultsAdminGrowthRatesFormCountyBedroom[];
    isChanged?: boolean;
}

export interface DefaultsAdminGrowthRatesFormBedroomType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface DefaultsAdminGrowthRatesFormPropertyType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface KeyDisplayValue {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface DefaultsAdminGrowthRatesFormBedroom extends Validatable {
    selectedBedroomType?: DefaultsAdminGrowthRatesFormBedroomType | undefined;
    growthRatePercentage?: string | undefined;
}

export interface DefaultsAdminGrowthRatesFormPropertyBedroom extends Validatable {
    selectedBedroomType?: DefaultsAdminGrowthRatesFormBedroomType | undefined;
    selectedPropertyType?: DefaultsAdminGrowthRatesFormPropertyType | undefined;
    growthRatePercentage?: string | undefined;
}

export interface DefaultsAdminGrowthRatesFormCountyBedroom extends Validatable {
    selectedBedroomType?: DefaultsAdminGrowthRatesFormBedroomType | undefined;
    selectedCountyType?: KeyDisplayValue | undefined;
    growthRatePercentage?: string | undefined;
}

export interface ResponsePayloadOfCreateBatchForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: CreateBatchForm | undefined;
}

export interface CreateBatchForm extends Validatable {
    key?: string | undefined;
    divisions?: CreateBatchFormDivision[];
    selectedDivision?: CreateBatchFormDivision | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    batchTypes?: CreateBatchFormBatchType[];
    selectedBatchTypes?: CreateBatchFormBatchType[];
}

export interface CreateBatchFormDivision extends Validatable {
    key?: string | undefined;
    displayValue?: string | undefined;
    properties?: CreateBatchFormProperty[];
    selectedProperties?: CreateBatchFormProperty[];
    noticePeriods?: string[];
}

export interface CreateBatchFormProperty {
    key?: string | undefined;
    displayValue?: string | undefined;
    renewalNotice?: number | undefined;
    county?: string | undefined;
    hasValidationError?: boolean;
    validationError?: string | undefined;
    units?: CreateBatchFormProperty[];
    selectedUnits?: CreateBatchFormProperty[];
}

export interface CreateBatchFormBatchType {
    key?: string | undefined;
    displayValue?: string | undefined;
    requiresStartDate?: boolean;
}

export interface ResponsePayloadOfCreateOneOffBatchForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: CreateOneOffBatchForm | undefined;
}

export interface CreateOneOffBatchForm extends Validatable {
    key?: string | undefined;
    divisions?: CreateOneOffBatchFormDivision[];
    selectedDivision?: CreateOneOffBatchFormDivision | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    batchTypes?: CreateOneOffBatchFormBatchType[];
    selectedBatchTypes?: CreateOneOffBatchFormBatchType[];
}

export interface CreateOneOffBatchFormDivision extends Validatable {
    key?: string | undefined;
    displayValue?: string | undefined;
    properties?: CreateOneOffBatchFormProperty[];
    selectedProperty?: CreateOneOffBatchFormProperty;
}

export interface CreateOneOffBatchFormProperty {
    key?: string | undefined;
    displayValue?: string | undefined;
    hasValidationError?: boolean;
    validationError?: string | undefined;
    units?: CreateOneOffBatchFormUnit[];
    selectedUnits?: CreateOneOffBatchFormUnit[];
}

export interface CreateOneOffBatchFormUnit {
    key?: string | undefined;
    displayValue?: string | undefined;
    hasValidationError?: boolean;
    validationError?: string | undefined;
}

export interface CreateOneOffBatchFormBatchType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface ResponsePayloadOfBestRenewalOffersForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BestRenewalOffersForm | undefined;
}

export interface BestRenewalOffersForm extends Validatable {
    batchDetail?: BatchDetail | undefined;
    approversVotedCount?: number | undefined;
    approversTotalCount?: number | undefined;
    rejectReason?: string;
    filters?: ReviewSummaryFormFilters | undefined;
    activeView?: CommonSummaryRollupKind;
    propertySummary?: CommonSummaryFormSummary | undefined;
    offers?: BestRenewalOffersFormOffer[];
    properties?: BestRenewalOffersFormProperty[];
    selectedPropertiesForFiltering?: BestRenewalOffersFormProperty[];
    selectedPropertyForComment?: BestRenewalOffersFormProperty | undefined;
    batchComments?: BestRenewalOffersFormBatchComments;
    columnConfigurations?: BestRenewalOfferColumnConfiguration[];
    pageConfiguration?: BestRenewalOfferPageConfiguration | undefined;
    navigationConfiguration?: BatchNavigationConfiguration | undefined;
}

export interface BestRenewalOffersFormOffer extends Validatable {
    key?: string | undefined;
    comments?: BestRenewalOffersFormComment[];
    property?: string | undefined;
    propertyKey?: string | undefined;
    unit?: string | undefined;
    rpm?: string | undefined;
    unitType?: string | undefined;
    affordabilityType?: string | undefined;
    bedrooms?: string | undefined;
    residentCode?: string | undefined;
    resident?: string | undefined;
    corporateOrEmployee?: string | undefined;
    leaseExpires?: Date | undefined;
    effectiveDate?: string | undefined;
    effectiveDateOverride?: string | undefined;
    termCategory?: string | undefined;
    tenantStatus?: string | undefined;
    excluded?: boolean;
    excludedReason?: string | undefined;
    currentRent?: string | undefined;
    currentNetEffectiveRent?: string | undefined;
    marketRent?: string | undefined;
    growthRatePercentage?: string | undefined;
    adjustedMarketRentDollars?: string | undefined;
    adjustedLtlOrGtlDollars?: string | undefined;
    adjustedLtlOrGtlPercentage?: string | undefined;
    ltlRecapPercentage?: string | undefined;
    ltlRecapDollars?: string | undefined;
    gtlRecapPercentage?: string | undefined;
    gtlRecapDollars?: string | undefined;
    minPercentage?: string | undefined;
    minDollars?: string | undefined;
    maxPercentage?: string | undefined;
    maxDollars?: string | undefined;
    dropRate?: string | undefined;
    parameter?: string | undefined;
    calculatedBestOfferDollars?: string | undefined;
    bestOfferDollars?: string | undefined;
    bestOfferOverrideDollars?: string | undefined;
    bestOfferOverridePercentage?: string | undefined;
    rentChangeDollars?: string | undefined;
    rentChangePercentage?: string | undefined;
    ltlOrGtlDollars?: string | undefined;
    ltlOrGtlPercentage?: string | undefined;
    offerToAdjustedToMarketRentDollars?: string | undefined;
    offerToAdjustedToMarketRentPercentage?: string | undefined;
    lastRentIncreaseDate?: string | undefined;
    rentOneYearAgo?: string | undefined;
    lastYearIncreaseDollar?: string | undefined;
    lastYearIncreasePercentage?: string | undefined;
    dateOfLastBatch?: string | undefined;
    isPropertyException?: boolean;
    isUnitException?: boolean;
    oneMonth?: string | undefined;
    twoMonths?: string | undefined;
    threeMonths?: string | undefined;
    fourMonths?: string | undefined;
    fiveMonths?: string | undefined;
    sixMonths?: string | undefined;
    sevenMonths?: string | undefined;
    eightMonths?: string | undefined;
    nineMonths?: string | undefined;
    tenMonths?: string | undefined;
    elevenMonths?: string | undefined;
    twelveMonths?: string | undefined;
    thirteenMonths?: string | undefined;
    fourteenMonths?: string | undefined;
    fifteenMonths?: string | undefined;
    anchorRent?: string | undefined;
    upfrontConcession?: string | undefined;
    recurringConcession?: string | undefined;
    newRecurringConcession?: number | undefined;
    newRecurringConcessionOverride?: string | undefined;
    netEffectiveIncreasePercent?: string | undefined;
    netEffectiveOffer?: string | undefined;
    isReha?: string | undefined;
    leaseDescription?: string | undefined;
    moveInDate?: string | undefined;
    maxAllowableRentDollars?: string | undefined;
    maxPercentByLaw?: string | undefined;
    maxRentByLaw?: string | undefined;
    maxImposed?: string | undefined;
    yearlyLowestRent?: string | undefined;
    renewalStatus?: string | undefined;
    actualOfferDate?: string | undefined;
    actualOfferDollar?: string | undefined;
    leasingAgentName?: string | undefined;
    leaseStatus?: string | undefined;
    currentTerm?: string | undefined;
    newTerm?: string | undefined;
    deviationDollar?: string | undefined;
    renewalGoalDate?: string | undefined;
    daysToFinalize?: string | undefined;
    isChanged?: boolean;
}

export interface BestRenewalOffersFormProperty {
    key?: string | undefined;
    displayValue?: string | undefined;
    comments?: BestRenewalOffersFormComment[];
}

export interface BestRenewalOfferColumnConfiguration {
    field?: string;
    isHidden?: boolean;
    header?: string;
    fieldType?: BestRenewalOfferColumnConfigurationFieldType;
}

export enum BestRenewalOfferColumnConfigurationFieldType {
    String = 0,
    Number = 1,
}

export interface BestRenewalOfferPageConfiguration {
    isEditEnabled?: boolean;
    isDeleteEnabled?: boolean;
    isSubmitEnabled?: boolean;
    isApprovalEnabled?: boolean;
    areCommentsEnabled?: boolean;
    isExportEnabled?: boolean;
    canDownloadBatchToCsv?: boolean;
    showExceptionFilters?: boolean;
    showPropertySummary?: boolean;
}

export interface ResponsePayloadOfBestRenewalOffersFormDownload {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BestRenewalOffersFormDownload | undefined;
}

export interface BestRenewalOffersFormDownload extends Validatable {
    fileLocation?: string;
}

export interface ResponsePayloadOfVoidResponse {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: VoidResponse | undefined;
}

export interface VoidResponse {
}

export interface ResponsePayloadOfListOfBestRenewalOffersFormComment {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BestRenewalOffersFormComment[] | undefined;
}

export interface ResponsePayloadOfBestRenewalOffersFormComment {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BestRenewalOffersFormComment | undefined;
}

export interface ResponsePayloadOfBestRenewalOffersFormCalculationResult {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BestRenewalOffersFormCalculationResult | undefined;
}

export interface BestRenewalOffersFormCalculationResult {
    propertySummary?: CommonSummaryFormSummary | undefined;
    offers?: BestRenewalOffersFormOffer[];
}

export interface ResponsePayloadOfBatchListForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BatchListForm | undefined;
}

export interface BatchListForm {
    notifications?: BatchListFormNotification[];
    divisions?: DivisionOption[];
    selectedDivision?: DivisionOption | undefined;
    batchTypes?: BatchTypeOption[];
    selectedBatchType?: BatchTypeOption | undefined;
    years?: YearOption[];
    selectedYear?: YearOption | undefined;
    versions?: BatchListFormVersion[];
    selectedVersion?: BatchListFormVersion | undefined;
    batches?: BatchListFormBatchDetail[];
    batchListFormConfiguration?: BatchListFormConfiguration | undefined;
}

export interface BatchListFormNotification {
    message?: string | undefined;
    isRead?: boolean;
}

export interface DivisionOption {
    displayValue?: string;
    key?: string;
}

export interface BatchTypeOption {
    displayValue?: string;
    key?: string;
}

export interface YearOption {
    displayValue?: string;
    key?: string;
}

export interface BatchListFormVersion {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BatchListFormBatchDetail {
    key?: string | undefined;
    division?: string | undefined;
    batchTypes?: BatchListFormBatchDetailBatchType[];
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    properties?: number;
    units?: number;
    version?: string | undefined;
    status?: string | undefined;
    rpmApprovals?: string | undefined;
    createdDate?: Date | undefined;
    lastUpdatedDate?: Date | undefined;
}

export interface BatchListFormBatchDetailBatchType {
    key?: string | undefined;
    batchTypeKind?: BatchTypeKind;
    displayValue?: string | undefined;
}

export interface BatchListFormConfiguration {
    hideVersion?: boolean;
    hideDivision?: boolean;
    hideRpmApprovals?: boolean;
    rpmApprovalsHeader?: string;
}

export interface ResponsePayloadOfBatchDefaultsScalingForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BatchDefaultsScalingForm | undefined;
}

export interface BatchDefaultsScalingForm extends Validatable {
    batchDetail?: BatchDetail;
    defaults?: BaselineDefaultsScalingForm;
}

export interface BaselineDefaultsScalingForm extends Validatable {
    divisions?: BaselineDefaultsScalingFormDivision[];
    selectedDivision?: BaselineDefaultsScalingFormDivision | undefined;
    pageConfiguration?: DefaultsPageConfiguration | undefined;
}

export interface BaselineDefaultsScalingFormDivision {
    key?: string | undefined;
    displayValue?: string | undefined;
    bedroomTypesForBedroomDefaults?: BaselineDefaultsScalingFormBedroomType[];
    bedroomTypesForPropertyBedroomDefaults?: BaselineDefaultsScalingFormBedroomType[];
    propertyTypes?: BaselineDefaultsScalingFormPropertyType[];
    defaults?: BaselineDefaultsScalingFormDefaults | undefined;
    bedroomDefaults?: BaselineDefaultsScalingFormDefaults[];
    propertyBedroomDefaults?: BaselineDefaultsScalingFormDefaults[];
    isChanged?: boolean;
}

export interface BaselineDefaultsScalingFormBedroomType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsScalingFormPropertyType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsScalingFormDefaults extends Validatable {
    oneMonth?: string | undefined;
    twoMonths?: string | undefined;
    threeMonths?: string | undefined;
    fourMonths?: string | undefined;
    fiveMonths?: string | undefined;
    sixMonths?: string | undefined;
    sevenMonths?: string | undefined;
    eightMonths?: string | undefined;
    nineMonths?: string | undefined;
    tenMonths?: string | undefined;
    elevenMonths?: string | undefined;
    twelveMonths?: string | undefined;
    thirteenMonths?: string | undefined;
    fourteenMonths?: string | undefined;
    fifteenMonths?: string | undefined;
    selectedPropertyType?: BaselineDefaultsScalingFormPropertyType | undefined;
    selectedBedroomType?: BaselineDefaultsScalingFormBedroomType | undefined;
}

export interface ResponsePayloadOfBatchDefaultsRentControlForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BatchDefaultsRentControlForm | undefined;
}

export interface BatchDefaultsRentControlForm extends Validatable {
    batchDetail?: BatchDetail;
    defaults?: BaselineDefaultsRentControlForm;
}

export interface BaselineDefaultsRentControlForm extends Validatable {
    divisions?: BaselineDefaultsRentControlFormDivision[];
    selectedDivision?: BaselineDefaultsRentControlFormDivision | undefined;
    pageConfiguration?: DefaultsPageConfiguration | undefined;
}

export interface BaselineDefaultsRentControlFormDivision {
    key?: string | undefined;
    displayValue?: string | undefined;
    propertyTypes?: BaselineDefaultsRentControlFormPropertyType[];
    rentControlTypes?: BaselineDefaultsRentControlFormRentControlType[];
    propertyDefaults?: BaselineDefaultsRentControlFormDefaults[];
    unitDefaults?: BaselineDefaultsRentControlFormDefaults[];
    isChanged?: boolean;
}

export interface BaselineDefaultsRentControlFormPropertyType {
    key?: string | undefined;
    displayValue?: string | undefined;
    county?: string | undefined;
}

export interface BaselineDefaultsRentControlFormRentControlType {
    key?: string | undefined;
    displayValue?: string | undefined;
    lastUpdatedDate?: string | undefined;
    lastUpdatedByKey?: string | undefined;
    limits?: BaselineDefaultsRentControlFormRentControlTypeLimit[];
}

export interface BaselineDefaultsRentControlFormRentControlTypeLimit {
    key?: string | undefined;
    effectiveDate?: string | undefined;
    maxPercentageByRevenueManager?: number | undefined;
    maxPercentageByLaw?: number | undefined;
    increasesAllowedInFirstTwelveMonths?: number | undefined;
    increasesAllowedAfterTwelveMonths?: number | undefined;
    lastUpdatedDate?: string | undefined;
    lastUpdatedByKey?: string | undefined;
}

export interface BaselineDefaultsRentControlFormDefaults extends Validatable {
    county?: string | undefined;
    selectedPropertyType?: BaselineDefaultsRentControlFormPropertyType | undefined;
    unitNumber?: string | undefined;
    selectedRentControlType?: BaselineDefaultsRentControlFormRentControlType | undefined;
    note?: string | undefined;
    lastUpdatedDate?: string | undefined;
    lastUpdatedBy?: string | undefined;
    lastUpdatedByKey?: string | undefined;
    isChanged?: boolean;
    maxPercentageByRevenueManager?: number | undefined;
    maxPercentageByLaw?: number | undefined;
    effectiveDate?: string | undefined;
}

export interface ResponsePayloadOfBatchDefaultsRentControlTypesForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BatchDefaultsRentControlTypesForm | undefined;
}

export interface BatchDefaultsRentControlTypesForm extends Validatable {
    batchDetail?: BatchDetail;
    defaults?: RentControlTypesForm;
}

export interface RentControlTypesForm extends Validatable {
    rentControlTypes?: RentControlTypesFormRentControlType[];
    limits?: RentControlTypesFormLimit[];
    pageConfiguration?: DefaultsPageConfiguration | undefined;
}

export interface RentControlTypesFormRentControlType extends Validatable {
    key?: string | undefined;
    displayValue?: string | undefined;
    isUsedByRentControlDefaults?: boolean;
    lastUpdatedDate?: string | undefined;
    lastUpdatedBy?: string | undefined;
    lastUpdatedByKey?: string | undefined;
    isChanged?: boolean;
}

export interface RentControlTypesFormLimit extends Validatable {
    key?: string | undefined;
    selectedRentControlType?: RentControlTypesFormRentControlType | undefined;
    effectiveDate?: string | undefined;
    maxPercentageByRevenueManager?: string | undefined;
    maxPercentageByLaw?: string | undefined;
    increasesAllowedInFirstTwelveMonths?: string | undefined;
    increasesAllowedAfterTwelveMonths?: string | undefined;
    lastUpdatedDate?: string | undefined;
    lastUpdatedBy?: string | undefined;
    lastUpdatedByKey?: string | undefined;
    isChanged?: boolean;
}

export interface ResponsePayloadOfBatchDefaultsRenewalNoticePeriodForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BatchDefaultsRenewalNoticePeriodForm | undefined;
}

export interface BatchDefaultsRenewalNoticePeriodForm extends Validatable {
    batchDetail?: BatchDetail;
    defaults?: BaselineDefaultsRenewalNoticePeriodForm;
}

export interface BaselineDefaultsRenewalNoticePeriodForm extends Validatable {
    divisions?: BaselineDefaultsRenewalNoticePeriodFormDivision[];
    selectedDivision?: BaselineDefaultsRenewalNoticePeriodFormDivision | undefined;
    pageConfiguration?: DefaultsPageConfiguration | undefined;
}

export interface BaselineDefaultsRenewalNoticePeriodFormDivision {
    key?: string | undefined;
    displayValue?: string | undefined;
    propertyTypes?: BaselineDefaultsRenewalNoticePeriodFormPropertyType[];
    countyTypes?: BaselineDefaultsRenewalNoticePeriodFormCountyType[];
    defaults?: BaselineDefaultsRenewalNoticePeriodFormDefaults | undefined;
    countyDefaults?: BaselineDefaultsRenewalNoticePeriodFormDefaults[];
    propertyDefaults?: BaselineDefaultsRenewalNoticePeriodFormDefaults[];
    isChanged?: boolean;
}

export interface BaselineDefaultsRenewalNoticePeriodFormPropertyType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsRenewalNoticePeriodFormCountyType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsRenewalNoticePeriodFormDefaults extends Validatable {
    noticePeriodDays?: string | undefined;
    selectedCountyType?: BaselineDefaultsRenewalNoticePeriodFormCountyType | undefined;
    selectedPropertyType?: BaselineDefaultsRenewalNoticePeriodFormPropertyType | undefined;
}

export interface ResponsePayloadOfBatchDefaultsRegulationsForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BatchDefaultsRegulationsForm | undefined;
}

export interface BatchDefaultsRegulationsForm extends Validatable {
    batchDetail?: BatchDetail;
    defaults?: BaselineDefaultsRegulationsForm;
}

export interface BaselineDefaultsRegulationsForm extends Validatable {
    divisions?: BaselineDefaultsRegulationsFormDivision[];
    selectedDivision?: BaselineDefaultsRegulationsFormDivision | undefined;
    pageConfiguration?: DefaultsPageConfiguration | undefined;
}

export interface BaselineDefaultsRegulationsFormDivision {
    key?: string | undefined;
    displayValue?: string | undefined;
    regulationTypes?: BaselineDefaultsRegulationsFormRegulationType[];
    propertyTypes?: BaselineDefaultsRegulationsFormPropertyType[];
    countyTypes?: BaselineDefaultsRegulationsFormCountyType[];
    countyDefaults?: BaselineDefaultsRegulationsFormDefaults[];
    propertyDefaults?: BaselineDefaultsRegulationsFormDefaults[];
    isChanged?: boolean;
}

export interface BaselineDefaultsRegulationsFormRegulationType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsRegulationsFormPropertyType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsRegulationsFormCountyType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsRegulationsFormDefaults extends Validatable {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    numberOfDays?: number | undefined;
    percentageCap?: string | undefined;
    regulationType?: BaselineDefaultsRegulationsFormRegulationType | undefined;
    selectedCountyType?: BaselineDefaultsRegulationsFormCountyType | undefined;
    selectedPropertyType?: BaselineDefaultsRegulationsFormPropertyType | undefined;
}

export interface ResponsePayloadOfBatchDefaultsIncentivesForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BatchDefaultsIncentivesForm | undefined;
}

export interface BatchDefaultsIncentivesForm extends Validatable {
    batchDetail?: BatchDetail;
    defaults?: BaselineDefaultsIncentivesForm;
}

export interface BaselineDefaultsIncentivesForm extends Validatable {
    divisions?: BaselineDefaultsIncentivesFormDivision[];
    selectedDivision?: BaselineDefaultsIncentivesFormDivision | undefined;
    pageConfiguration?: DefaultsPageConfiguration | undefined;
}

export interface BaselineDefaultsIncentivesFormDivision {
    key?: string | undefined;
    displayValue?: string | undefined;
    incentiveTypes?: BaselineDefaultsIncentivesFormIncentiveType[];
    bedroomTypes?: BaselineDefaultsIncentivesFormBedroomType[];
    propertyTypes?: BaselineDefaultsIncentivesFormPropertyType[];
    defaults?: BaselineDefaultsIncentivesFormDefaults | undefined;
    bedroomDefaults?: BaselineDefaultsIncentivesFormDefaults[];
    propertyDefaults?: BaselineDefaultsIncentivesFormDefaults[];
    propertyUnitDefaults?: BaselineDefaultsIncentivesFormDefaults[];
    isChanged?: boolean;
}

export interface BaselineDefaultsIncentivesFormIncentiveType {
    key?: string;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsIncentivesFormBedroomType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsIncentivesFormPropertyType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsIncentivesFormDefaults extends Validatable {
    incentiveValue?: string | undefined;
    selectedIncentiveType?: BaselineDefaultsIncentivesFormIncentiveType | undefined;
    selectedBedroomType?: BaselineDefaultsIncentivesFormBedroomType | undefined;
    selectedPropertyType?: BaselineDefaultsIncentivesFormPropertyType | undefined;
    unitNumber?: string | undefined;
    isChanged?: boolean;
}

export interface ResponsePayloadOfBatchDefaultsHousingAuthorityScalingForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BatchDefaultsHousingAuthorityScalingForm | undefined;
}

export interface BatchDefaultsHousingAuthorityScalingForm extends Validatable {
    batchDetail?: BatchDetail;
    defaults?: BaselineDefaultsHousingAuthorityScalingForm;
}

export interface BaselineDefaultsHousingAuthorityScalingForm extends Validatable {
    divisions?: BaselineDefaultsHousingAuthorityScalingFormDivision[];
    selectedDivision?: BaselineDefaultsHousingAuthorityScalingFormDivision | undefined;
    pageConfiguration?: DefaultsPageConfiguration | undefined;
}

export interface BaselineDefaultsHousingAuthorityScalingFormDivision {
    key?: string | undefined;
    displayValue?: string | undefined;
    countyTypes?: BaselineDefaultsHousingAuthorityScalingFormCountyType[];
    propertyTypes?: BaselineDefaultsHousingAuthorityScalingFormPropertyType[];
    countyDefaults?: BaselineDefaultsHousingAuthorityScalingFormDefaults[];
    propertyDefaults?: BaselineDefaultsHousingAuthorityScalingFormDefaults[];
    isChanged?: boolean;
}

export interface BaselineDefaultsHousingAuthorityScalingFormCountyType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsHousingAuthorityScalingFormPropertyType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsHousingAuthorityScalingFormDefaults extends Validatable {
    oneMonth?: string | undefined;
    twoMonths?: string | undefined;
    threeMonths?: string | undefined;
    fourMonths?: string | undefined;
    fiveMonths?: string | undefined;
    sixMonths?: string | undefined;
    sevenMonths?: string | undefined;
    eightMonths?: string | undefined;
    nineMonths?: string | undefined;
    tenMonths?: string | undefined;
    elevenMonths?: string | undefined;
    twelveMonths?: string | undefined;
    thirteenMonths?: string | undefined;
    fourteenMonths?: string | undefined;
    fifteenMonths?: string | undefined;
    selectedPropertyType?: BaselineDefaultsHousingAuthorityScalingFormPropertyType | undefined;
    selectedCountyType?: BaselineDefaultsHousingAuthorityScalingFormCountyType | undefined;
}

export interface ResponsePayloadOfBatchDefaultsGtlAndLtlForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BatchDefaultsGtlAndLtlForm | undefined;
}

export interface BatchDefaultsGtlAndLtlForm extends Validatable {
    batchDetail?: BatchDetail;
    defaults?: DefaultsAdminGtlAndLtlForm;
}

export interface ResponsePayloadOfBatchDefaultsGrowthRatesForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BatchDefaultsGrowthRatesForm | undefined;
}

export interface BatchDefaultsGrowthRatesForm extends Validatable {
    batchDetail?: BatchDetail;
    defaults?: DefaultsAdminGrowthRatesForm | undefined;
}

export interface ResponsePayloadOfBatchDefaultsExportTermsForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BatchDefaultsExportTermsForm | undefined;
}

export interface BatchDefaultsExportTermsForm extends Validatable {
    batchDetail?: BatchDetail;
    defaults?: BaselineDefaultsExportTermsForm;
}

export interface BaselineDefaultsExportTermsForm extends Validatable {
    divisions?: BaselineDefaultsExportTermsFormDivision[];
    selectedDivision?: BaselineDefaultsExportTermsFormDivision | undefined;
    pageConfiguration?: DefaultsPageConfiguration | undefined;
}

export interface BaselineDefaultsExportTermsFormDivision {
    key?: string | undefined;
    displayValue?: string | undefined;
    bedroomTypesForBedroomDefaults?: BaselineDefaultsExportTermsFormBedroomType[];
    bedroomTypesForPropertyBedroomDefaults?: BaselineDefaultsExportTermsFormBedroomType[];
    propertyTypes?: BaselineDefaultsExportTermsFormPropertyType[];
    defaults?: BaselineDefaultsExportTermsFormDefaults | undefined;
    bedroomDefaults?: BaselineDefaultsExportTermsFormDefaults[];
    propertyBedroomDefaults?: BaselineDefaultsExportTermsFormDefaults[];
    isChanged?: boolean;
}

export interface BaselineDefaultsExportTermsFormBedroomType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsExportTermsFormPropertyType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsExportTermsFormDefaults extends Validatable {
    oneMonth?: boolean | undefined;
    twoMonths?: boolean | undefined;
    threeMonths?: boolean | undefined;
    fourMonths?: boolean | undefined;
    fiveMonths?: boolean | undefined;
    sixMonths?: boolean | undefined;
    sevenMonths?: boolean | undefined;
    eightMonths?: boolean | undefined;
    nineMonths?: boolean | undefined;
    tenMonths?: boolean | undefined;
    elevenMonths?: boolean | undefined;
    twelveMonths?: boolean | undefined;
    thirteenMonths?: boolean | undefined;
    fourteenMonths?: boolean | undefined;
    fifteenMonths?: boolean | undefined;
    selectedPropertyType?: BaselineDefaultsExportTermsFormPropertyType | undefined;
    selectedBedroomType?: BaselineDefaultsExportTermsFormBedroomType | undefined;
}

export interface ResponsePayloadOfBatchDefaultsExceptionsForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BatchDefaultsExceptionsForm | undefined;
}

export interface BatchDefaultsExceptionsForm extends Validatable {
    batchDetail?: BatchDetail;
    defaults?: BaselineDefaultsExceptionsForm;
}

export interface BaselineDefaultsExceptionsForm extends Validatable {
    divisions?: BaselineDefaultsExceptionsFormDivision[];
    selectedDivision?: BaselineDefaultsExceptionsFormDivision | undefined;
    pageConfiguration?: DefaultsPageConfiguration | undefined;
}

export interface BaselineDefaultsExceptionsFormDivision {
    key?: string | undefined;
    displayValue?: string | undefined;
    propertyTypes?: BaselineDefaultsExceptionsFormPropertyType[];
    countyTypes?: BaselineDefaultsExceptionsFormCountyType[];
    defaults?: BaselineDefaultsExceptionsFormDefaults | undefined;
    countyDefaults?: BaselineDefaultsExceptionsFormDefaults[];
    propertyDefaults?: BaselineDefaultsExceptionsFormDefaults[];
    isChanged?: boolean;
}

export interface BaselineDefaultsExceptionsFormPropertyType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsExceptionsFormCountyType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsExceptionsFormDefaults extends Validatable {
    propertyAverageBelowPercentage?: string | undefined;
    propertyAverageAbovePercentage?: string | undefined;
    propertyLtlThresholdPercentage?: string | undefined;
    propertyGtlThresholdPercentage?: string | undefined;
    unitLtlThresholdPercentage?: string | undefined;
    unitGtlThresholdPercentage?: string | undefined;
    selectedCountyType?: BaselineDefaultsExceptionsFormCountyType | undefined;
    selectedPropertyType?: BaselineDefaultsExceptionsFormPropertyType | undefined;
}

export interface ResponsePayloadOfBatchDefaultsBmrForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BatchDefaultsBmrForm | undefined;
}

export interface BatchDefaultsBmrForm extends Validatable {
    batchDetail?: BatchDetail | undefined;
    defaults?: BaselineDefaultsBmrForm | undefined;
}

export interface BaselineDefaultsBmrForm extends Validatable {
    divisions?: BaselineDefaultsBmrFormDivision[];
    selectedDivision?: BaselineDefaultsBmrFormDivision | undefined;
    pageConfiguration?: DefaultsPageConfiguration | undefined;
}

export interface BaselineDefaultsBmrFormDivision {
    key?: string | undefined;
    displayValue?: string | undefined;
    propertyTypes?: BaselineDefaultsBmrFormPropertyType[];
    bedroomTypes?: BaselineDefaultsBmrFormBedroomType[];
    affordabilityTypes?: BaselineDefaultsBmrFormAffordabilityType[];
    propertyBedroomAffordabilityDefaults?: BaselineDefaultsBmrFormDefaults[];
    isChanged?: boolean;
}

export interface BaselineDefaultsBmrFormPropertyType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsBmrFormBedroomType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsBmrFormAffordabilityType {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface BaselineDefaultsBmrFormDefaults extends Validatable {
    selectedPropertyType?: BaselineDefaultsBmrFormPropertyType | undefined;
    selectedBedroomType?: BaselineDefaultsBmrFormBedroomType | undefined;
    selectedAffordabilityType?: BaselineDefaultsBmrFormAffordabilityType | undefined;
    minAllowableDollar?: string | undefined;
    maxAllowableDollar?: string | undefined;
    minAllowablePercentage?: string | undefined;
    maxAllowablePercentage?: string | undefined;
    lastUpdatedDate?: string | undefined;
    lastUpdatedBy?: string | undefined;
    lastUpdatedByKey?: string | undefined;
    isChanged?: boolean;
}

export interface ResponsePayloadOfBaselineDefaultsRenewalNoticePeriodForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BaselineDefaultsRenewalNoticePeriodForm | undefined;
}

export interface ResponsePayloadOfBaselineDefaultsRegulationsForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BaselineDefaultsRegulationsForm | undefined;
}

export interface ResponsePayloadOfBaselineDefaultsExportTermsForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BaselineDefaultsExportTermsForm | undefined;
}

export interface ResponsePayloadOfBaselineDefaultsHousingAuthorityScalingForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BaselineDefaultsHousingAuthorityScalingForm | undefined;
}

export interface ResponsePayloadOfBaselineDefaultsIncentivesForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BaselineDefaultsIncentivesForm | undefined;
}

export interface ResponsePayloadOfBaselineDefaultsRentControlForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BaselineDefaultsRentControlForm | undefined;
}

export interface ResponsePayloadOfBaselineDefaultsScalingForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BaselineDefaultsScalingForm | undefined;
}

export interface ResponsePayloadOfRentControlTypesForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: RentControlTypesForm | undefined;
}

export interface ResponsePayloadOfBaselineDefaultsExceptionsForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BaselineDefaultsExceptionsForm | undefined;
}

export interface ResponsePayloadOfBaselineDefaultsBmrForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: BaselineDefaultsBmrForm | undefined;
}

export interface ResponsePayloadOfActualResultsSummaryForm {
    traceId?: string;
    userRoles?: UserRoleKind[];
    permissions?: UserPermissions;
    data?: ActualResultsSummaryForm | undefined;
}

export interface ActualResultsSummaryForm {
    batchDetail?: BatchDetail | undefined;
    filters?: ActualResultsSummaryFormFilters | undefined;
    renewalStatusSummary?: ActualResultsSummaryFormRenewalStatusSummary | undefined;
    navigationConfiguration?: BatchNavigationConfiguration | undefined;
}

export interface ActualResultsSummaryFormFilters {
    propertyFilters?: ActualResultsSummaryFormFilter[];
    selectedPropertyFilter?: ActualResultsSummaryFormFilter | undefined;
}

export interface ActualResultsSummaryFormFilter {
    key?: string | undefined;
    displayValue?: string | undefined;
}

export interface ActualResultsSummaryFormRenewalStatusSummary {
    renewalStatusRollups?: ActualResultsSummaryFormRenewalStatusRollup[];
    rollupTotals?: ActualResultsSummaryFormRenewalStatusRollup | undefined;
}

export interface ActualResultsSummaryFormRenewalStatusRollup {
    status?: string | undefined;
    count?: string | undefined;
    capturePercentage?: string | undefined;
    averageDaysToFinalize?: string | undefined;
    percentageFinalizedWithinGoal?: string | undefined;
    rentIncreaseOfferDollars?: string | undefined;
    rentIncreaseOfferPercentage?: string | undefined;
    rentIncreaseActualDollars?: string | undefined;
    rentIncreaseActualPercentage?: string | undefined;
    deviationFromOffer?: string | undefined;
    deviationCount?: string | undefined;
    ltlGtlMarketRentDollars?: string | undefined;
    ltlGtlMarketRentPercentage?: string | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}